/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * Reflex API
 * OpenAPI spec version: 1.0.0
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  MutationFunction,
  QueryFunction,
  QueryKey,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  AdminBillingEntityDetail
} from './model/adminBillingEntityDetail';

import type {
  AdminEnterpriseIdentityStatus
} from './model/adminEnterpriseIdentityStatus';

import type {
  AdminOkResponse
} from './model/adminOkResponse';

import type {
  AdminOrganizationBillingEntity
} from './model/adminOrganizationBillingEntity';

import type {
  AdminOrganizationBillingEntityMoveResult
} from './model/adminOrganizationBillingEntityMoveResult';

import type {
  AdminSuccessResponse
} from './model/adminSuccessResponse';

import type {
  ApproveAdminBillingEntityDomainClaimBody
} from './model/approveAdminBillingEntityDomainClaimBody';

import type {
  BillingEntity
} from './model/billingEntity';

import type {
  BillingEntityDomainClaim
} from './model/billingEntityDomainClaim';

import type {
  BillingEntityOidcConnection
} from './model/billingEntityOidcConnection';

import type {
  CreateAdminBillingEntityBody
} from './model/createAdminBillingEntityBody';

import type {
  CreateAdminBillingEntityDomainClaimBody
} from './model/createAdminBillingEntityDomainClaimBody';

import type {
  CreateAdminOrganizationBody
} from './model/createAdminOrganizationBody';

import type {
  CreateProvisionedAdminOrganizationBody
} from './model/createProvisionedAdminOrganizationBody';

import type {
  DeleteAdminBillingEntityOidcConnectionBody
} from './model/deleteAdminBillingEntityOidcConnectionBody';

import type {
  DeleteAdminEmailDomainBody
} from './model/deleteAdminEmailDomainBody';

import type {
  DeleteServiceSecret200
} from './model/deleteServiceSecret200';

import type {
  EmailSettings
} from './model/emailSettings';

import type {
  EraseAdminUser200
} from './model/eraseAdminUser200';

import type {
  EraseAdminUserBody
} from './model/eraseAdminUserBody';

import type {
  ErrorEnvelope
} from './model/errorEnvelope';

import type {
  GetAdminAgentModels200
} from './model/getAdminAgentModels200';

import type {
  GetAdminSecretsRegistry200Item
} from './model/getAdminSecretsRegistry200Item';

import type {
  GetAdminSecretsStatus200
} from './model/getAdminSecretsStatus200';

import type {
  GetAdminStatus200
} from './model/getAdminStatus200';

import type {
  GetAdminUserErasure200
} from './model/getAdminUserErasure200';

import type {
  GetAdminUserOrganizations200
} from './model/getAdminUserOrganizations200';

import type {
  GetAdminWebhookActivity200
} from './model/getAdminWebhookActivity200';

import type {
  GetPluginServiceConfig200
} from './model/getPluginServiceConfig200';

import type {
  GetSecretManagerStatus200
} from './model/getSecretManagerStatus200';

import type {
  GetServiceSecretRegistry200Item
} from './model/getServiceSecretRegistry200Item';

import type {
  GrantAppAdmin201
} from './model/grantAppAdmin201';

import type {
  GrantAppAdminBody
} from './model/grantAppAdminBody';

import type {
  ListAdminBillingEntities200
} from './model/listAdminBillingEntities200';

import type {
  ListAdminBillingEntityDomainClaims200
} from './model/listAdminBillingEntityDomainClaims200';

import type {
  ListAdminEmailDomains200
} from './model/listAdminEmailDomains200';

import type {
  ListAdminEmailDomainsParams
} from './model/listAdminEmailDomainsParams';

import type {
  ListAdminOrganizations200
} from './model/listAdminOrganizations200';

import type {
  ListAdminOrganizationsParams
} from './model/listAdminOrganizationsParams';

import type {
  ListAdminUsers200
} from './model/listAdminUsers200';

import type {
  ListAdminUsersParams
} from './model/listAdminUsersParams';

import type {
  ListAppAdmins200
} from './model/listAppAdmins200';

import type {
  MaintenanceState
} from './model/maintenanceState';

import type {
  OrgActivitySummary
} from './model/orgActivitySummary';

import type {
  Organization
} from './model/organization';

import type {
  ProviderAccount
} from './model/providerAccount';

import type {
  ReassignAdminEmailDomain200
} from './model/reassignAdminEmailDomain200';

import type {
  ReassignAdminEmailDomainBody
} from './model/reassignAdminEmailDomainBody';

import type {
  RemoveAdminBillingEntityDomainClaimBody
} from './model/removeAdminBillingEntityDomainClaimBody';

import type {
  ReplaceAdminBillingEntityOidcConnectionBody
} from './model/replaceAdminBillingEntityOidcConnectionBody';

import type {
  ReviewAdminUserErasure200
} from './model/reviewAdminUserErasure200';

import type {
  ReviewAdminUserErasureBody
} from './model/reviewAdminUserErasureBody';

import type {
  RotateSecrets200
} from './model/rotateSecrets200';

import type {
  RotateSecretsBody
} from './model/rotateSecretsBody';

import type {
  SecretMutationResponse
} from './model/secretMutationResponse';

import type {
  ServiceSettings
} from './model/serviceSettings';

import type {
  SetAdminOrganizationBillingEntityBody
} from './model/setAdminOrganizationBillingEntityBody';

import type {
  SetAdminOrganizationCapabilitiesBody
} from './model/setAdminOrganizationCapabilitiesBody';

import type {
  SetAdminOrganizationCapabilityBody
} from './model/setAdminOrganizationCapabilityBody';

import type {
  SetAdminOrganizationStatusBody
} from './model/setAdminOrganizationStatusBody';

import type {
  SetAdminOrganizationSubscriptionTierBody
} from './model/setAdminOrganizationSubscriptionTierBody';

import type {
  SetAdminSecretBody
} from './model/setAdminSecretBody';

import type {
  SetAdminUserStatusBody
} from './model/setAdminUserStatusBody';

import type {
  SetAdminWebhookDrainRate200
} from './model/setAdminWebhookDrainRate200';

import type {
  SetAdminWebhookDrainRateBody
} from './model/setAdminWebhookDrainRateBody';

import type {
  SetAgentModelAvailabilityBody
} from './model/setAgentModelAvailabilityBody';

import type {
  SetAgentModelDefaultBody
} from './model/setAgentModelDefaultBody';

import type {
  SetAgentModelProviderAvailabilityBody
} from './model/setAgentModelProviderAvailabilityBody';

import type {
  SetAgentTypeEnabledBody
} from './model/setAgentTypeEnabledBody';

import type {
  SetLaunchDefaultAgentBody
} from './model/setLaunchDefaultAgentBody';

import type {
  SetOrganizationSubscriptionBody
} from './model/setOrganizationSubscriptionBody';

import type {
  SetServiceSecret200
} from './model/setServiceSecret200';

import type {
  SetServiceSecretBody
} from './model/setServiceSecretBody';

import type {
  UpdateAdminBillingEntityBody
} from './model/updateAdminBillingEntityBody';

import type {
  UpdateAdminBillingEntityDomainClaimPolicyBody
} from './model/updateAdminBillingEntityDomainClaimPolicyBody';

import type {
  UpdatePluginServiceConfig200
} from './model/updatePluginServiceConfig200';

import type {
  UpdatePluginServiceConfigBody
} from './model/updatePluginServiceConfigBody';

import type {
  User
} from './model/user';

import type {
  VerifyAdminBillingEntityDomainClaim200
} from './model/verifyAdminBillingEntityDomainClaim200';

import { apiFetch } from '../api/mutator';



type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

export const getAdminAgentModels = (

 options?: SecondParameter<typeof apiFetch>,signal?: AbortSignal
) => {


      return apiFetch<GetAdminAgentModels200>(
      {url: `/admin/agent-models`, method: 'GET', signal
    },
      options);
    }




export const getGetAdminAgentModelsQueryKey = () => {
    return [
    `/admin/agent-models`
    ] as const;
    }


export const getGetAdminAgentModelsQueryOptions = <TData = Awaited<ReturnType<typeof getAdminAgentModels>>, TError = unknown>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getAdminAgentModels>>, TError, TData>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAdminAgentModelsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAdminAgentModels>>> = ({ signal }) => getAdminAgentModels(requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAdminAgentModels>>, TError, TData> & { queryKey: QueryKey }
}

export type GetAdminAgentModelsQueryResult = NonNullable<Awaited<ReturnType<typeof getAdminAgentModels>>>
export type GetAdminAgentModelsQueryError = unknown



export function useGetAdminAgentModels<TData = Awaited<ReturnType<typeof getAdminAgentModels>>, TError = unknown>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getAdminAgentModels>>, TError, TData>, request?: SecondParameter<typeof apiFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetAdminAgentModelsQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}






export const setAgentModelDefault = (
    agentType: string,
    setAgentModelDefaultBody: SetAgentModelDefaultBody,
 options?: SecondParameter<typeof apiFetch>,signal?: AbortSignal
) => {


      return apiFetch<AdminSuccessResponse>(
      {url: `/admin/agent-models/${encodeURIComponent(String(agentType))}/default`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: setAgentModelDefaultBody, signal
    },
      options);
    }




export const getSetAgentModelDefaultMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof setAgentModelDefault>>, TError,{agentType: string;data: SetAgentModelDefaultBody}, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof setAgentModelDefault>>, TError,{agentType: string;data: SetAgentModelDefaultBody}, TContext> => {

const mutationKey = ['setAgentModelDefault'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof setAgentModelDefault>>, {agentType: string;data: SetAgentModelDefaultBody}> = (props) => {
          const {agentType,data} = props ?? {};

          return  setAgentModelDefault(agentType,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type SetAgentModelDefaultMutationResult = NonNullable<Awaited<ReturnType<typeof setAgentModelDefault>>>
    export type SetAgentModelDefaultMutationBody = SetAgentModelDefaultBody
    export type SetAgentModelDefaultMutationError = unknown

    export const useSetAgentModelDefault = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof setAgentModelDefault>>, TError,{agentType: string;data: SetAgentModelDefaultBody}, TContext>, request?: SecondParameter<typeof apiFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof setAgentModelDefault>>,
        TError,
        {agentType: string;data: SetAgentModelDefaultBody},
        TContext
      > => {
      return useMutation(getSetAgentModelDefaultMutationOptions(options));
    }
    export const setAgentTypeEnabled = (
    agentType: string,
    setAgentTypeEnabledBody: SetAgentTypeEnabledBody,
 options?: SecondParameter<typeof apiFetch>,signal?: AbortSignal
) => {


      return apiFetch<AdminSuccessResponse>(
      {url: `/admin/agent-models/${encodeURIComponent(String(agentType))}/enabled`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: setAgentTypeEnabledBody, signal
    },
      options);
    }




export const getSetAgentTypeEnabledMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof setAgentTypeEnabled>>, TError,{agentType: string;data: SetAgentTypeEnabledBody}, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof setAgentTypeEnabled>>, TError,{agentType: string;data: SetAgentTypeEnabledBody}, TContext> => {

const mutationKey = ['setAgentTypeEnabled'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof setAgentTypeEnabled>>, {agentType: string;data: SetAgentTypeEnabledBody}> = (props) => {
          const {agentType,data} = props ?? {};

          return  setAgentTypeEnabled(agentType,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type SetAgentTypeEnabledMutationResult = NonNullable<Awaited<ReturnType<typeof setAgentTypeEnabled>>>
    export type SetAgentTypeEnabledMutationBody = SetAgentTypeEnabledBody
    export type SetAgentTypeEnabledMutationError = unknown

    export const useSetAgentTypeEnabled = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof setAgentTypeEnabled>>, TError,{agentType: string;data: SetAgentTypeEnabledBody}, TContext>, request?: SecondParameter<typeof apiFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof setAgentTypeEnabled>>,
        TError,
        {agentType: string;data: SetAgentTypeEnabledBody},
        TContext
      > => {
      return useMutation(getSetAgentTypeEnabledMutationOptions(options));
    }
    export const setAgentModelAvailability = (
    agentType: string,
    modelId: string,
    setAgentModelAvailabilityBody: SetAgentModelAvailabilityBody,
 options?: SecondParameter<typeof apiFetch>,signal?: AbortSignal
) => {


      return apiFetch<AdminSuccessResponse>(
      {url: `/admin/agent-models/${encodeURIComponent(String(agentType))}/models/${encodeURIComponent(String(modelId))}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: setAgentModelAvailabilityBody, signal
    },
      options);
    }




export const getSetAgentModelAvailabilityMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof setAgentModelAvailability>>, TError,{agentType: string;modelId: string;data: SetAgentModelAvailabilityBody}, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof setAgentModelAvailability>>, TError,{agentType: string;modelId: string;data: SetAgentModelAvailabilityBody}, TContext> => {

const mutationKey = ['setAgentModelAvailability'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof setAgentModelAvailability>>, {agentType: string;modelId: string;data: SetAgentModelAvailabilityBody}> = (props) => {
          const {agentType,modelId,data} = props ?? {};

          return  setAgentModelAvailability(agentType,modelId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type SetAgentModelAvailabilityMutationResult = NonNullable<Awaited<ReturnType<typeof setAgentModelAvailability>>>
    export type SetAgentModelAvailabilityMutationBody = SetAgentModelAvailabilityBody
    export type SetAgentModelAvailabilityMutationError = unknown

    export const useSetAgentModelAvailability = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof setAgentModelAvailability>>, TError,{agentType: string;modelId: string;data: SetAgentModelAvailabilityBody}, TContext>, request?: SecondParameter<typeof apiFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof setAgentModelAvailability>>,
        TError,
        {agentType: string;modelId: string;data: SetAgentModelAvailabilityBody},
        TContext
      > => {
      return useMutation(getSetAgentModelAvailabilityMutationOptions(options));
    }
    export const setAgentModelProviderAvailability = (
    agentType: string,
    providerId: string,
    setAgentModelProviderAvailabilityBody: SetAgentModelProviderAvailabilityBody,
 options?: SecondParameter<typeof apiFetch>,signal?: AbortSignal
) => {


      return apiFetch<AdminSuccessResponse>(
      {url: `/admin/agent-models/${encodeURIComponent(String(agentType))}/providers/${encodeURIComponent(String(providerId))}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: setAgentModelProviderAvailabilityBody, signal
    },
      options);
    }




export const getSetAgentModelProviderAvailabilityMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof setAgentModelProviderAvailability>>, TError,{agentType: string;providerId: string;data: SetAgentModelProviderAvailabilityBody}, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof setAgentModelProviderAvailability>>, TError,{agentType: string;providerId: string;data: SetAgentModelProviderAvailabilityBody}, TContext> => {

const mutationKey = ['setAgentModelProviderAvailability'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof setAgentModelProviderAvailability>>, {agentType: string;providerId: string;data: SetAgentModelProviderAvailabilityBody}> = (props) => {
          const {agentType,providerId,data} = props ?? {};

          return  setAgentModelProviderAvailability(agentType,providerId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type SetAgentModelProviderAvailabilityMutationResult = NonNullable<Awaited<ReturnType<typeof setAgentModelProviderAvailability>>>
    export type SetAgentModelProviderAvailabilityMutationBody = SetAgentModelProviderAvailabilityBody
    export type SetAgentModelProviderAvailabilityMutationError = unknown

    export const useSetAgentModelProviderAvailability = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof setAgentModelProviderAvailability>>, TError,{agentType: string;providerId: string;data: SetAgentModelProviderAvailabilityBody}, TContext>, request?: SecondParameter<typeof apiFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof setAgentModelProviderAvailability>>,
        TError,
        {agentType: string;providerId: string;data: SetAgentModelProviderAvailabilityBody},
        TContext
      > => {
      return useMutation(getSetAgentModelProviderAvailabilityMutationOptions(options));
    }
    export const setLaunchDefaultAgent = (
    setLaunchDefaultAgentBody: SetLaunchDefaultAgentBody,
 options?: SecondParameter<typeof apiFetch>,signal?: AbortSignal
) => {


      return apiFetch<AdminSuccessResponse>(
      {url: `/admin/agent-models/launch-default-agent`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: setLaunchDefaultAgentBody, signal
    },
      options);
    }




export const getSetLaunchDefaultAgentMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof setLaunchDefaultAgent>>, TError,{data: SetLaunchDefaultAgentBody}, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof setLaunchDefaultAgent>>, TError,{data: SetLaunchDefaultAgentBody}, TContext> => {

const mutationKey = ['setLaunchDefaultAgent'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof setLaunchDefaultAgent>>, {data: SetLaunchDefaultAgentBody}> = (props) => {
          const {data} = props ?? {};

          return  setLaunchDefaultAgent(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type SetLaunchDefaultAgentMutationResult = NonNullable<Awaited<ReturnType<typeof setLaunchDefaultAgent>>>
    export type SetLaunchDefaultAgentMutationBody = SetLaunchDefaultAgentBody
    export type SetLaunchDefaultAgentMutationError = unknown

    export const useSetLaunchDefaultAgent = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof setLaunchDefaultAgent>>, TError,{data: SetLaunchDefaultAgentBody}, TContext>, request?: SecondParameter<typeof apiFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof setLaunchDefaultAgent>>,
        TError,
        {data: SetLaunchDefaultAgentBody},
        TContext
      > => {
      return useMutation(getSetLaunchDefaultAgentMutationOptions(options));
    }
    export const listAppAdmins = (

 options?: SecondParameter<typeof apiFetch>,signal?: AbortSignal
) => {


      return apiFetch<ListAppAdmins200>(
      {url: `/admin/app-admins`, method: 'GET', signal
    },
      options);
    }




export const getListAppAdminsQueryKey = () => {
    return [
    `/admin/app-admins`
    ] as const;
    }


export const getListAppAdminsQueryOptions = <TData = Awaited<ReturnType<typeof listAppAdmins>>, TError = unknown>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listAppAdmins>>, TError, TData>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListAppAdminsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listAppAdmins>>> = ({ signal }) => listAppAdmins(requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listAppAdmins>>, TError, TData> & { queryKey: QueryKey }
}

export type ListAppAdminsQueryResult = NonNullable<Awaited<ReturnType<typeof listAppAdmins>>>
export type ListAppAdminsQueryError = unknown



export function useListAppAdmins<TData = Awaited<ReturnType<typeof listAppAdmins>>, TError = unknown>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listAppAdmins>>, TError, TData>, request?: SecondParameter<typeof apiFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListAppAdminsQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}






export const grantAppAdmin = (
    grantAppAdminBody: GrantAppAdminBody,
 options?: SecondParameter<typeof apiFetch>,signal?: AbortSignal
) => {


      return apiFetch<GrantAppAdmin201>(
      {url: `/admin/app-admins`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: grantAppAdminBody, signal
    },
      options);
    }




export const getGrantAppAdminMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof grantAppAdmin>>, TError,{data: GrantAppAdminBody}, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof grantAppAdmin>>, TError,{data: GrantAppAdminBody}, TContext> => {

const mutationKey = ['grantAppAdmin'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof grantAppAdmin>>, {data: GrantAppAdminBody}> = (props) => {
          const {data} = props ?? {};

          return  grantAppAdmin(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type GrantAppAdminMutationResult = NonNullable<Awaited<ReturnType<typeof grantAppAdmin>>>
    export type GrantAppAdminMutationBody = GrantAppAdminBody
    export type GrantAppAdminMutationError = unknown

    export const useGrantAppAdmin = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof grantAppAdmin>>, TError,{data: GrantAppAdminBody}, TContext>, request?: SecondParameter<typeof apiFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof grantAppAdmin>>,
        TError,
        {data: GrantAppAdminBody},
        TContext
      > => {
      return useMutation(getGrantAppAdminMutationOptions(options));
    }
    export const revokeAppAdmin = (
    userId: string,
 options?: SecondParameter<typeof apiFetch>,signal?: AbortSignal
) => {


      return apiFetch<AdminOkResponse>(
      {url: `/admin/app-admins/${encodeURIComponent(String(userId))}`, method: 'DELETE', signal
    },
      options);
    }




export const getRevokeAppAdminMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof revokeAppAdmin>>, TError,{userId: string}, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof revokeAppAdmin>>, TError,{userId: string}, TContext> => {

const mutationKey = ['revokeAppAdmin'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof revokeAppAdmin>>, {userId: string}> = (props) => {
          const {userId} = props ?? {};

          return  revokeAppAdmin(userId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type RevokeAppAdminMutationResult = NonNullable<Awaited<ReturnType<typeof revokeAppAdmin>>>

    export type RevokeAppAdminMutationError = unknown

    export const useRevokeAppAdmin = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof revokeAppAdmin>>, TError,{userId: string}, TContext>, request?: SecondParameter<typeof apiFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof revokeAppAdmin>>,
        TError,
        {userId: string},
        TContext
      > => {
      return useMutation(getRevokeAppAdminMutationOptions(options));
    }
    /**
 * @summary List billing entities (commercial owners of organizations).
 */
export const listAdminBillingEntities = (

 options?: SecondParameter<typeof apiFetch>,signal?: AbortSignal
) => {


      return apiFetch<ListAdminBillingEntities200>(
      {url: `/admin/billing-entities`, method: 'GET', signal
    },
      options);
    }




export const getListAdminBillingEntitiesQueryKey = () => {
    return [
    `/admin/billing-entities`
    ] as const;
    }


export const getListAdminBillingEntitiesQueryOptions = <TData = Awaited<ReturnType<typeof listAdminBillingEntities>>, TError = unknown>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listAdminBillingEntities>>, TError, TData>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListAdminBillingEntitiesQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listAdminBillingEntities>>> = ({ signal }) => listAdminBillingEntities(requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listAdminBillingEntities>>, TError, TData> & { queryKey: QueryKey }
}

export type ListAdminBillingEntitiesQueryResult = NonNullable<Awaited<ReturnType<typeof listAdminBillingEntities>>>
export type ListAdminBillingEntitiesQueryError = unknown


/**
 * @summary List billing entities (commercial owners of organizations).
 */

export function useListAdminBillingEntities<TData = Awaited<ReturnType<typeof listAdminBillingEntities>>, TError = unknown>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listAdminBillingEntities>>, TError, TData>, request?: SecondParameter<typeof apiFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListAdminBillingEntitiesQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * @summary Create a billing entity.
 */
export const createAdminBillingEntity = (
    createAdminBillingEntityBody: CreateAdminBillingEntityBody,
 options?: SecondParameter<typeof apiFetch>,signal?: AbortSignal
) => {


      return apiFetch<BillingEntity>(
      {url: `/admin/billing-entities`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: createAdminBillingEntityBody, signal
    },
      options);
    }




export const getCreateAdminBillingEntityMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createAdminBillingEntity>>, TError,{data: CreateAdminBillingEntityBody}, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createAdminBillingEntity>>, TError,{data: CreateAdminBillingEntityBody}, TContext> => {

const mutationKey = ['createAdminBillingEntity'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createAdminBillingEntity>>, {data: CreateAdminBillingEntityBody}> = (props) => {
          const {data} = props ?? {};

          return  createAdminBillingEntity(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateAdminBillingEntityMutationResult = NonNullable<Awaited<ReturnType<typeof createAdminBillingEntity>>>
    export type CreateAdminBillingEntityMutationBody = CreateAdminBillingEntityBody
    export type CreateAdminBillingEntityMutationError = unknown

    /**
 * @summary Create a billing entity.
 */
export const useCreateAdminBillingEntity = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createAdminBillingEntity>>, TError,{data: CreateAdminBillingEntityBody}, TContext>, request?: SecondParameter<typeof apiFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof createAdminBillingEntity>>,
        TError,
        {data: CreateAdminBillingEntityBody},
        TContext
      > => {
      return useMutation(getCreateAdminBillingEntityMutationOptions(options));
    }
    /**
 * @summary Get a billing entity and the organizations it owns.
 */
export const getAdminBillingEntity = (
    billingEntityId: string,
 options?: SecondParameter<typeof apiFetch>,signal?: AbortSignal
) => {


      return apiFetch<AdminBillingEntityDetail>(
      {url: `/admin/billing-entities/${encodeURIComponent(String(billingEntityId))}`, method: 'GET', signal
    },
      options);
    }




export const getGetAdminBillingEntityQueryKey = (billingEntityId: string,) => {
    return [
    `/admin/billing-entities/${billingEntityId}`
    ] as const;
    }


export const getGetAdminBillingEntityQueryOptions = <TData = Awaited<ReturnType<typeof getAdminBillingEntity>>, TError = unknown>(billingEntityId: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getAdminBillingEntity>>, TError, TData>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAdminBillingEntityQueryKey(billingEntityId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAdminBillingEntity>>> = ({ signal }) => getAdminBillingEntity(billingEntityId, requestOptions, signal);





   return  { queryKey, queryFn, enabled: billingEntityId !== null && billingEntityId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAdminBillingEntity>>, TError, TData> & { queryKey: QueryKey }
}

export type GetAdminBillingEntityQueryResult = NonNullable<Awaited<ReturnType<typeof getAdminBillingEntity>>>
export type GetAdminBillingEntityQueryError = unknown


/**
 * @summary Get a billing entity and the organizations it owns.
 */

export function useGetAdminBillingEntity<TData = Awaited<ReturnType<typeof getAdminBillingEntity>>, TError = unknown>(
 billingEntityId: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getAdminBillingEntity>>, TError, TData>, request?: SecondParameter<typeof apiFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetAdminBillingEntityQueryOptions(billingEntityId,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * @summary Rename a billing entity or change its subscription tier.
 */
export const updateAdminBillingEntity = (
    billingEntityId: string,
    updateAdminBillingEntityBody: UpdateAdminBillingEntityBody,
 options?: SecondParameter<typeof apiFetch>,signal?: AbortSignal
) => {


      return apiFetch<BillingEntity>(
      {url: `/admin/billing-entities/${encodeURIComponent(String(billingEntityId))}`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: updateAdminBillingEntityBody, signal
    },
      options);
    }




export const getUpdateAdminBillingEntityMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateAdminBillingEntity>>, TError,{billingEntityId: string;data: UpdateAdminBillingEntityBody}, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof updateAdminBillingEntity>>, TError,{billingEntityId: string;data: UpdateAdminBillingEntityBody}, TContext> => {

const mutationKey = ['updateAdminBillingEntity'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateAdminBillingEntity>>, {billingEntityId: string;data: UpdateAdminBillingEntityBody}> = (props) => {
          const {billingEntityId,data} = props ?? {};

          return  updateAdminBillingEntity(billingEntityId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateAdminBillingEntityMutationResult = NonNullable<Awaited<ReturnType<typeof updateAdminBillingEntity>>>
    export type UpdateAdminBillingEntityMutationBody = UpdateAdminBillingEntityBody
    export type UpdateAdminBillingEntityMutationError = unknown

    /**
 * @summary Rename a billing entity or change its subscription tier.
 */
export const useUpdateAdminBillingEntity = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateAdminBillingEntity>>, TError,{billingEntityId: string;data: UpdateAdminBillingEntityBody}, TContext>, request?: SecondParameter<typeof apiFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof updateAdminBillingEntity>>,
        TError,
        {billingEntityId: string;data: UpdateAdminBillingEntityBody},
        TContext
      > => {
      return useMutation(getUpdateAdminBillingEntityMutationOptions(options));
    }
    /**
 * @summary List a billing entity's email-domain claims.
 */
export const listAdminBillingEntityDomainClaims = (
    billingEntityId: string,
 options?: SecondParameter<typeof apiFetch>,signal?: AbortSignal
) => {


      return apiFetch<ListAdminBillingEntityDomainClaims200>(
      {url: `/admin/billing-entities/${encodeURIComponent(String(billingEntityId))}/domain-claims`, method: 'GET', signal
    },
      options);
    }




export const getListAdminBillingEntityDomainClaimsQueryKey = (billingEntityId: string,) => {
    return [
    `/admin/billing-entities/${billingEntityId}/domain-claims`
    ] as const;
    }


export const getListAdminBillingEntityDomainClaimsQueryOptions = <TData = Awaited<ReturnType<typeof listAdminBillingEntityDomainClaims>>, TError = unknown>(billingEntityId: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listAdminBillingEntityDomainClaims>>, TError, TData>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListAdminBillingEntityDomainClaimsQueryKey(billingEntityId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listAdminBillingEntityDomainClaims>>> = ({ signal }) => listAdminBillingEntityDomainClaims(billingEntityId, requestOptions, signal);





   return  { queryKey, queryFn, enabled: billingEntityId !== null && billingEntityId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listAdminBillingEntityDomainClaims>>, TError, TData> & { queryKey: QueryKey }
}

export type ListAdminBillingEntityDomainClaimsQueryResult = NonNullable<Awaited<ReturnType<typeof listAdminBillingEntityDomainClaims>>>
export type ListAdminBillingEntityDomainClaimsQueryError = unknown


/**
 * @summary List a billing entity's email-domain claims.
 */

export function useListAdminBillingEntityDomainClaims<TData = Awaited<ReturnType<typeof listAdminBillingEntityDomainClaims>>, TError = unknown>(
 billingEntityId: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listAdminBillingEntityDomainClaims>>, TError, TData>, request?: SecondParameter<typeof apiFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListAdminBillingEntityDomainClaimsQueryOptions(billingEntityId,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * @summary Claim an email domain for a billing entity and get its DNS TXT challenge; audited.
 */
export const createAdminBillingEntityDomainClaim = (
    billingEntityId: string,
    createAdminBillingEntityDomainClaimBody: CreateAdminBillingEntityDomainClaimBody,
 options?: SecondParameter<typeof apiFetch>,signal?: AbortSignal
) => {


      return apiFetch<BillingEntityDomainClaim>(
      {url: `/admin/billing-entities/${encodeURIComponent(String(billingEntityId))}/domain-claims`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: createAdminBillingEntityDomainClaimBody, signal
    },
      options);
    }




export const getCreateAdminBillingEntityDomainClaimMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createAdminBillingEntityDomainClaim>>, TError,{billingEntityId: string;data: CreateAdminBillingEntityDomainClaimBody}, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createAdminBillingEntityDomainClaim>>, TError,{billingEntityId: string;data: CreateAdminBillingEntityDomainClaimBody}, TContext> => {

const mutationKey = ['createAdminBillingEntityDomainClaim'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createAdminBillingEntityDomainClaim>>, {billingEntityId: string;data: CreateAdminBillingEntityDomainClaimBody}> = (props) => {
          const {billingEntityId,data} = props ?? {};

          return  createAdminBillingEntityDomainClaim(billingEntityId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateAdminBillingEntityDomainClaimMutationResult = NonNullable<Awaited<ReturnType<typeof createAdminBillingEntityDomainClaim>>>
    export type CreateAdminBillingEntityDomainClaimMutationBody = CreateAdminBillingEntityDomainClaimBody
    export type CreateAdminBillingEntityDomainClaimMutationError = unknown

    /**
 * @summary Claim an email domain for a billing entity and get its DNS TXT challenge; audited.
 */
export const useCreateAdminBillingEntityDomainClaim = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createAdminBillingEntityDomainClaim>>, TError,{billingEntityId: string;data: CreateAdminBillingEntityDomainClaimBody}, TContext>, request?: SecondParameter<typeof apiFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof createAdminBillingEntityDomainClaim>>,
        TError,
        {billingEntityId: string;data: CreateAdminBillingEntityDomainClaimBody},
        TContext
      > => {
      return useMutation(getCreateAdminBillingEntityDomainClaimMutationOptions(options));
    }
    /**
 * @summary Override a claim's consumption policy directly (support escape hatch); takes a reason and is audited as a platform-admin act.
 */
export const updateAdminBillingEntityDomainClaimPolicy = (
    billingEntityId: string,
    claimId: string,
    updateAdminBillingEntityDomainClaimPolicyBody: UpdateAdminBillingEntityDomainClaimPolicyBody,
 options?: SecondParameter<typeof apiFetch>,signal?: AbortSignal
) => {


      return apiFetch<BillingEntityDomainClaim>(
      {url: `/admin/billing-entities/${encodeURIComponent(String(billingEntityId))}/domain-claims/${encodeURIComponent(String(claimId))}`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: updateAdminBillingEntityDomainClaimPolicyBody, signal
    },
      options);
    }




export const getUpdateAdminBillingEntityDomainClaimPolicyMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateAdminBillingEntityDomainClaimPolicy>>, TError,{billingEntityId: string;claimId: string;data: UpdateAdminBillingEntityDomainClaimPolicyBody}, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof updateAdminBillingEntityDomainClaimPolicy>>, TError,{billingEntityId: string;claimId: string;data: UpdateAdminBillingEntityDomainClaimPolicyBody}, TContext> => {

const mutationKey = ['updateAdminBillingEntityDomainClaimPolicy'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateAdminBillingEntityDomainClaimPolicy>>, {billingEntityId: string;claimId: string;data: UpdateAdminBillingEntityDomainClaimPolicyBody}> = (props) => {
          const {billingEntityId,claimId,data} = props ?? {};

          return  updateAdminBillingEntityDomainClaimPolicy(billingEntityId,claimId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateAdminBillingEntityDomainClaimPolicyMutationResult = NonNullable<Awaited<ReturnType<typeof updateAdminBillingEntityDomainClaimPolicy>>>
    export type UpdateAdminBillingEntityDomainClaimPolicyMutationBody = UpdateAdminBillingEntityDomainClaimPolicyBody
    export type UpdateAdminBillingEntityDomainClaimPolicyMutationError = unknown

    /**
 * @summary Override a claim's consumption policy directly (support escape hatch); takes a reason and is audited as a platform-admin act.
 */
export const useUpdateAdminBillingEntityDomainClaimPolicy = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateAdminBillingEntityDomainClaimPolicy>>, TError,{billingEntityId: string;claimId: string;data: UpdateAdminBillingEntityDomainClaimPolicyBody}, TContext>, request?: SecondParameter<typeof apiFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof updateAdminBillingEntityDomainClaimPolicy>>,
        TError,
        {billingEntityId: string;claimId: string;data: UpdateAdminBillingEntityDomainClaimPolicyBody},
        TContext
      > => {
      return useMutation(getUpdateAdminBillingEntityDomainClaimPolicyMutationOptions(options));
    }
    /**
 * @summary Remove a billing entity's email-domain claim; audited.
 */
export const removeAdminBillingEntityDomainClaim = (
    billingEntityId: string,
    claimId: string,
    removeAdminBillingEntityDomainClaimBody: RemoveAdminBillingEntityDomainClaimBody,
 options?: SecondParameter<typeof apiFetch>,signal?: AbortSignal
) => {


      return apiFetch<null>(
      {url: `/admin/billing-entities/${encodeURIComponent(String(billingEntityId))}/domain-claims/${encodeURIComponent(String(claimId))}`, method: 'DELETE',
      headers: {'Content-Type': 'application/json', },
      data: removeAdminBillingEntityDomainClaimBody, signal
    },
      options);
    }




export const getRemoveAdminBillingEntityDomainClaimMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof removeAdminBillingEntityDomainClaim>>, TError,{billingEntityId: string;claimId: string;data: RemoveAdminBillingEntityDomainClaimBody}, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof removeAdminBillingEntityDomainClaim>>, TError,{billingEntityId: string;claimId: string;data: RemoveAdminBillingEntityDomainClaimBody}, TContext> => {

const mutationKey = ['removeAdminBillingEntityDomainClaim'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof removeAdminBillingEntityDomainClaim>>, {billingEntityId: string;claimId: string;data: RemoveAdminBillingEntityDomainClaimBody}> = (props) => {
          const {billingEntityId,claimId,data} = props ?? {};

          return  removeAdminBillingEntityDomainClaim(billingEntityId,claimId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type RemoveAdminBillingEntityDomainClaimMutationResult = NonNullable<Awaited<ReturnType<typeof removeAdminBillingEntityDomainClaim>>>
    export type RemoveAdminBillingEntityDomainClaimMutationBody = RemoveAdminBillingEntityDomainClaimBody
    export type RemoveAdminBillingEntityDomainClaimMutationError = unknown

    /**
 * @summary Remove a billing entity's email-domain claim; audited.
 */
export const useRemoveAdminBillingEntityDomainClaim = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof removeAdminBillingEntityDomainClaim>>, TError,{billingEntityId: string;claimId: string;data: RemoveAdminBillingEntityDomainClaimBody}, TContext>, request?: SecondParameter<typeof apiFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof removeAdminBillingEntityDomainClaim>>,
        TError,
        {billingEntityId: string;claimId: string;data: RemoveAdminBillingEntityDomainClaimBody},
        TContext
      > => {
      return useMutation(getRemoveAdminBillingEntityDomainClaimMutationOptions(options));
    }
    /**
 * @summary Approve a claim without public DNS proof (dedicated-VPC split-horizon exception); audited.
 */
export const approveAdminBillingEntityDomainClaim = (
    billingEntityId: string,
    claimId: string,
    approveAdminBillingEntityDomainClaimBody: ApproveAdminBillingEntityDomainClaimBody,
 options?: SecondParameter<typeof apiFetch>,signal?: AbortSignal
) => {


      return apiFetch<BillingEntityDomainClaim>(
      {url: `/admin/billing-entities/${encodeURIComponent(String(billingEntityId))}/domain-claims/${encodeURIComponent(String(claimId))}/approve`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: approveAdminBillingEntityDomainClaimBody, signal
    },
      options);
    }




export const getApproveAdminBillingEntityDomainClaimMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof approveAdminBillingEntityDomainClaim>>, TError,{billingEntityId: string;claimId: string;data: ApproveAdminBillingEntityDomainClaimBody}, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof approveAdminBillingEntityDomainClaim>>, TError,{billingEntityId: string;claimId: string;data: ApproveAdminBillingEntityDomainClaimBody}, TContext> => {

const mutationKey = ['approveAdminBillingEntityDomainClaim'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof approveAdminBillingEntityDomainClaim>>, {billingEntityId: string;claimId: string;data: ApproveAdminBillingEntityDomainClaimBody}> = (props) => {
          const {billingEntityId,claimId,data} = props ?? {};

          return  approveAdminBillingEntityDomainClaim(billingEntityId,claimId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ApproveAdminBillingEntityDomainClaimMutationResult = NonNullable<Awaited<ReturnType<typeof approveAdminBillingEntityDomainClaim>>>
    export type ApproveAdminBillingEntityDomainClaimMutationBody = ApproveAdminBillingEntityDomainClaimBody
    export type ApproveAdminBillingEntityDomainClaimMutationError = unknown

    /**
 * @summary Approve a claim without public DNS proof (dedicated-VPC split-horizon exception); audited.
 */
export const useApproveAdminBillingEntityDomainClaim = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof approveAdminBillingEntityDomainClaim>>, TError,{billingEntityId: string;claimId: string;data: ApproveAdminBillingEntityDomainClaimBody}, TContext>, request?: SecondParameter<typeof apiFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof approveAdminBillingEntityDomainClaim>>,
        TError,
        {billingEntityId: string;claimId: string;data: ApproveAdminBillingEntityDomainClaimBody},
        TContext
      > => {
      return useMutation(getApproveAdminBillingEntityDomainClaimMutationOptions(options));
    }
    /**
 * @summary Check DNS for a billing entity's TXT challenge now.
 */
export const verifyAdminBillingEntityDomainClaim = (
    billingEntityId: string,
    claimId: string,
 options?: SecondParameter<typeof apiFetch>,signal?: AbortSignal
) => {


      return apiFetch<VerifyAdminBillingEntityDomainClaim200>(
      {url: `/admin/billing-entities/${encodeURIComponent(String(billingEntityId))}/domain-claims/${encodeURIComponent(String(claimId))}/verify`, method: 'POST', signal
    },
      options);
    }




export const getVerifyAdminBillingEntityDomainClaimMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof verifyAdminBillingEntityDomainClaim>>, TError,{billingEntityId: string;claimId: string}, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof verifyAdminBillingEntityDomainClaim>>, TError,{billingEntityId: string;claimId: string}, TContext> => {

const mutationKey = ['verifyAdminBillingEntityDomainClaim'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof verifyAdminBillingEntityDomainClaim>>, {billingEntityId: string;claimId: string}> = (props) => {
          const {billingEntityId,claimId} = props ?? {};

          return  verifyAdminBillingEntityDomainClaim(billingEntityId,claimId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type VerifyAdminBillingEntityDomainClaimMutationResult = NonNullable<Awaited<ReturnType<typeof verifyAdminBillingEntityDomainClaim>>>

    export type VerifyAdminBillingEntityDomainClaimMutationError = unknown

    /**
 * @summary Check DNS for a billing entity's TXT challenge now.
 */
export const useVerifyAdminBillingEntityDomainClaim = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof verifyAdminBillingEntityDomainClaim>>, TError,{billingEntityId: string;claimId: string}, TContext>, request?: SecondParameter<typeof apiFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof verifyAdminBillingEntityDomainClaim>>,
        TError,
        {billingEntityId: string;claimId: string},
        TContext
      > => {
      return useMutation(getVerifyAdminBillingEntityDomainClaimMutationOptions(options));
    }
    export const getAdminBillingEntityOidcConnection = (
    billingEntityId: string,
 options?: SecondParameter<typeof apiFetch>,signal?: AbortSignal
) => {


      return apiFetch<BillingEntityOidcConnection>(
      {url: `/admin/billing-entities/${encodeURIComponent(String(billingEntityId))}/enterprise-identity/oidc-connection`, method: 'GET', signal
    },
      options);
    }




export const getGetAdminBillingEntityOidcConnectionQueryKey = (billingEntityId: string,) => {
    return [
    `/admin/billing-entities/${billingEntityId}/enterprise-identity/oidc-connection`
    ] as const;
    }


export const getGetAdminBillingEntityOidcConnectionQueryOptions = <TData = Awaited<ReturnType<typeof getAdminBillingEntityOidcConnection>>, TError = unknown>(billingEntityId: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getAdminBillingEntityOidcConnection>>, TError, TData>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAdminBillingEntityOidcConnectionQueryKey(billingEntityId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAdminBillingEntityOidcConnection>>> = ({ signal }) => getAdminBillingEntityOidcConnection(billingEntityId, requestOptions, signal);





   return  { queryKey, queryFn, enabled: billingEntityId !== null && billingEntityId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAdminBillingEntityOidcConnection>>, TError, TData> & { queryKey: QueryKey }
}

export type GetAdminBillingEntityOidcConnectionQueryResult = NonNullable<Awaited<ReturnType<typeof getAdminBillingEntityOidcConnection>>>
export type GetAdminBillingEntityOidcConnectionQueryError = unknown



export function useGetAdminBillingEntityOidcConnection<TData = Awaited<ReturnType<typeof getAdminBillingEntityOidcConnection>>, TError = unknown>(
 billingEntityId: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getAdminBillingEntityOidcConnection>>, TError, TData>, request?: SecondParameter<typeof apiFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetAdminBillingEntityOidcConnectionQueryOptions(billingEntityId,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}






export const replaceAdminBillingEntityOidcConnection = (
    billingEntityId: string,
    replaceAdminBillingEntityOidcConnectionBody: ReplaceAdminBillingEntityOidcConnectionBody,
 options?: SecondParameter<typeof apiFetch>,signal?: AbortSignal
) => {


      return apiFetch<BillingEntityOidcConnection>(
      {url: `/admin/billing-entities/${encodeURIComponent(String(billingEntityId))}/enterprise-identity/oidc-connection`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: replaceAdminBillingEntityOidcConnectionBody, signal
    },
      options);
    }




export const getReplaceAdminBillingEntityOidcConnectionMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof replaceAdminBillingEntityOidcConnection>>, TError,{billingEntityId: string;data: ReplaceAdminBillingEntityOidcConnectionBody}, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof replaceAdminBillingEntityOidcConnection>>, TError,{billingEntityId: string;data: ReplaceAdminBillingEntityOidcConnectionBody}, TContext> => {

const mutationKey = ['replaceAdminBillingEntityOidcConnection'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof replaceAdminBillingEntityOidcConnection>>, {billingEntityId: string;data: ReplaceAdminBillingEntityOidcConnectionBody}> = (props) => {
          const {billingEntityId,data} = props ?? {};

          return  replaceAdminBillingEntityOidcConnection(billingEntityId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ReplaceAdminBillingEntityOidcConnectionMutationResult = NonNullable<Awaited<ReturnType<typeof replaceAdminBillingEntityOidcConnection>>>
    export type ReplaceAdminBillingEntityOidcConnectionMutationBody = ReplaceAdminBillingEntityOidcConnectionBody
    export type ReplaceAdminBillingEntityOidcConnectionMutationError = unknown

    export const useReplaceAdminBillingEntityOidcConnection = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof replaceAdminBillingEntityOidcConnection>>, TError,{billingEntityId: string;data: ReplaceAdminBillingEntityOidcConnectionBody}, TContext>, request?: SecondParameter<typeof apiFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof replaceAdminBillingEntityOidcConnection>>,
        TError,
        {billingEntityId: string;data: ReplaceAdminBillingEntityOidcConnectionBody},
        TContext
      > => {
      return useMutation(getReplaceAdminBillingEntityOidcConnectionMutationOptions(options));
    }
    export const deleteAdminBillingEntityOidcConnection = (
    billingEntityId: string,
    deleteAdminBillingEntityOidcConnectionBody: DeleteAdminBillingEntityOidcConnectionBody,
 options?: SecondParameter<typeof apiFetch>,signal?: AbortSignal
) => {


      return apiFetch<null>(
      {url: `/admin/billing-entities/${encodeURIComponent(String(billingEntityId))}/enterprise-identity/oidc-connection`, method: 'DELETE',
      headers: {'Content-Type': 'application/json', },
      data: deleteAdminBillingEntityOidcConnectionBody, signal
    },
      options);
    }




export const getDeleteAdminBillingEntityOidcConnectionMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteAdminBillingEntityOidcConnection>>, TError,{billingEntityId: string;data: DeleteAdminBillingEntityOidcConnectionBody}, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteAdminBillingEntityOidcConnection>>, TError,{billingEntityId: string;data: DeleteAdminBillingEntityOidcConnectionBody}, TContext> => {

const mutationKey = ['deleteAdminBillingEntityOidcConnection'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteAdminBillingEntityOidcConnection>>, {billingEntityId: string;data: DeleteAdminBillingEntityOidcConnectionBody}> = (props) => {
          const {billingEntityId,data} = props ?? {};

          return  deleteAdminBillingEntityOidcConnection(billingEntityId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteAdminBillingEntityOidcConnectionMutationResult = NonNullable<Awaited<ReturnType<typeof deleteAdminBillingEntityOidcConnection>>>
    export type DeleteAdminBillingEntityOidcConnectionMutationBody = DeleteAdminBillingEntityOidcConnectionBody
    export type DeleteAdminBillingEntityOidcConnectionMutationError = unknown

    export const useDeleteAdminBillingEntityOidcConnection = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteAdminBillingEntityOidcConnection>>, TError,{billingEntityId: string;data: DeleteAdminBillingEntityOidcConnectionBody}, TContext>, request?: SecondParameter<typeof apiFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof deleteAdminBillingEntityOidcConnection>>,
        TError,
        {billingEntityId: string;data: DeleteAdminBillingEntityOidcConnectionBody},
        TContext
      > => {
      return useMutation(getDeleteAdminBillingEntityOidcConnectionMutationOptions(options));
    }
    /**
 * @summary Find company-owned email-domain claims.
 */
export const listAdminEmailDomains = (
    params?: ListAdminEmailDomainsParams,
 options?: SecondParameter<typeof apiFetch>,signal?: AbortSignal
) => {


      return apiFetch<ListAdminEmailDomains200>(
      {url: `/admin/email-domains`, method: 'GET',
        params, signal
    },
      options);
    }




export const getListAdminEmailDomainsQueryKey = (params?: ListAdminEmailDomainsParams,) => {
    return [
    `/admin/email-domains`, ...(params ? [params] : [])
    ] as const;
    }


export const getListAdminEmailDomainsQueryOptions = <TData = Awaited<ReturnType<typeof listAdminEmailDomains>>, TError = unknown>(params?: ListAdminEmailDomainsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listAdminEmailDomains>>, TError, TData>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListAdminEmailDomainsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listAdminEmailDomains>>> = ({ signal }) => listAdminEmailDomains(params, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listAdminEmailDomains>>, TError, TData> & { queryKey: QueryKey }
}

export type ListAdminEmailDomainsQueryResult = NonNullable<Awaited<ReturnType<typeof listAdminEmailDomains>>>
export type ListAdminEmailDomainsQueryError = unknown


/**
 * @summary Find company-owned email-domain claims.
 */

export function useListAdminEmailDomains<TData = Awaited<ReturnType<typeof listAdminEmailDomains>>, TError = unknown>(
 params?: ListAdminEmailDomainsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listAdminEmailDomains>>, TError, TData>, request?: SecondParameter<typeof apiFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListAdminEmailDomainsQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * @summary Remove a company-owned email-domain claim.
 */
export const deleteAdminEmailDomain = (
    domain: string,
    deleteAdminEmailDomainBody: DeleteAdminEmailDomainBody,
 options?: SecondParameter<typeof apiFetch>,signal?: AbortSignal
) => {


      return apiFetch<null>(
      {url: `/admin/email-domains/${encodeURIComponent(String(domain))}`, method: 'DELETE',
      headers: {'Content-Type': 'application/json', },
      data: deleteAdminEmailDomainBody, signal
    },
      options);
    }




export const getDeleteAdminEmailDomainMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteAdminEmailDomain>>, TError,{domain: string;data: DeleteAdminEmailDomainBody}, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteAdminEmailDomain>>, TError,{domain: string;data: DeleteAdminEmailDomainBody}, TContext> => {

const mutationKey = ['deleteAdminEmailDomain'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteAdminEmailDomain>>, {domain: string;data: DeleteAdminEmailDomainBody}> = (props) => {
          const {domain,data} = props ?? {};

          return  deleteAdminEmailDomain(domain,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteAdminEmailDomainMutationResult = NonNullable<Awaited<ReturnType<typeof deleteAdminEmailDomain>>>
    export type DeleteAdminEmailDomainMutationBody = DeleteAdminEmailDomainBody
    export type DeleteAdminEmailDomainMutationError = unknown

    /**
 * @summary Remove a company-owned email-domain claim.
 */
export const useDeleteAdminEmailDomain = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteAdminEmailDomain>>, TError,{domain: string;data: DeleteAdminEmailDomainBody}, TContext>, request?: SecondParameter<typeof apiFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof deleteAdminEmailDomain>>,
        TError,
        {domain: string;data: DeleteAdminEmailDomainBody},
        TContext
      > => {
      return useMutation(getDeleteAdminEmailDomainMutationOptions(options));
    }
    /**
 * @summary Reassign an email-domain claim to another company.
 */
export const reassignAdminEmailDomain = (
    domain: string,
    reassignAdminEmailDomainBody: ReassignAdminEmailDomainBody,
 options?: SecondParameter<typeof apiFetch>,signal?: AbortSignal
) => {


      return apiFetch<ReassignAdminEmailDomain200>(
      {url: `/admin/email-domains/${encodeURIComponent(String(domain))}/reassign`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: reassignAdminEmailDomainBody, signal
    },
      options);
    }




export const getReassignAdminEmailDomainMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof reassignAdminEmailDomain>>, TError,{domain: string;data: ReassignAdminEmailDomainBody}, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof reassignAdminEmailDomain>>, TError,{domain: string;data: ReassignAdminEmailDomainBody}, TContext> => {

const mutationKey = ['reassignAdminEmailDomain'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof reassignAdminEmailDomain>>, {domain: string;data: ReassignAdminEmailDomainBody}> = (props) => {
          const {domain,data} = props ?? {};

          return  reassignAdminEmailDomain(domain,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ReassignAdminEmailDomainMutationResult = NonNullable<Awaited<ReturnType<typeof reassignAdminEmailDomain>>>
    export type ReassignAdminEmailDomainMutationBody = ReassignAdminEmailDomainBody
    export type ReassignAdminEmailDomainMutationError = unknown

    /**
 * @summary Reassign an email-domain claim to another company.
 */
export const useReassignAdminEmailDomain = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof reassignAdminEmailDomain>>, TError,{domain: string;data: ReassignAdminEmailDomainBody}, TContext>, request?: SecondParameter<typeof apiFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof reassignAdminEmailDomain>>,
        TError,
        {domain: string;data: ReassignAdminEmailDomainBody},
        TContext
      > => {
      return useMutation(getReassignAdminEmailDomainMutationOptions(options));
    }
    export const getEmailSettings = (

 options?: SecondParameter<typeof apiFetch>,signal?: AbortSignal
) => {


      return apiFetch<EmailSettings>(
      {url: `/admin/email/settings`, method: 'GET', signal
    },
      options);
    }




export const getGetEmailSettingsQueryKey = () => {
    return [
    `/admin/email/settings`
    ] as const;
    }


export const getGetEmailSettingsQueryOptions = <TData = Awaited<ReturnType<typeof getEmailSettings>>, TError = unknown>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getEmailSettings>>, TError, TData>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetEmailSettingsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getEmailSettings>>> = ({ signal }) => getEmailSettings(requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getEmailSettings>>, TError, TData> & { queryKey: QueryKey }
}

export type GetEmailSettingsQueryResult = NonNullable<Awaited<ReturnType<typeof getEmailSettings>>>
export type GetEmailSettingsQueryError = unknown



export function useGetEmailSettings<TData = Awaited<ReturnType<typeof getEmailSettings>>, TError = unknown>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getEmailSettings>>, TError, TData>, request?: SecondParameter<typeof apiFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetEmailSettingsQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getMaintenance = (

 options?: SecondParameter<typeof apiFetch>,signal?: AbortSignal
) => {


      return apiFetch<MaintenanceState>(
      {url: `/admin/maintenance`, method: 'GET', signal
    },
      options);
    }




export const getGetMaintenanceQueryKey = () => {
    return [
    `/admin/maintenance`
    ] as const;
    }


export const getGetMaintenanceQueryOptions = <TData = Awaited<ReturnType<typeof getMaintenance>>, TError = unknown>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getMaintenance>>, TError, TData>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetMaintenanceQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getMaintenance>>> = ({ signal }) => getMaintenance(requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getMaintenance>>, TError, TData> & { queryKey: QueryKey }
}

export type GetMaintenanceQueryResult = NonNullable<Awaited<ReturnType<typeof getMaintenance>>>
export type GetMaintenanceQueryError = unknown



export function useGetMaintenance<TData = Awaited<ReturnType<typeof getMaintenance>>, TError = unknown>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getMaintenance>>, TError, TData>, request?: SecondParameter<typeof apiFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetMaintenanceQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}






export const setMaintenance = (
    maintenanceState: MaintenanceState,
 options?: SecondParameter<typeof apiFetch>,signal?: AbortSignal
) => {


      return apiFetch<MaintenanceState>(
      {url: `/admin/maintenance`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: maintenanceState, signal
    },
      options);
    }




export const getSetMaintenanceMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof setMaintenance>>, TError,{data: MaintenanceState}, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof setMaintenance>>, TError,{data: MaintenanceState}, TContext> => {

const mutationKey = ['setMaintenance'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof setMaintenance>>, {data: MaintenanceState}> = (props) => {
          const {data} = props ?? {};

          return  setMaintenance(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type SetMaintenanceMutationResult = NonNullable<Awaited<ReturnType<typeof setMaintenance>>>
    export type SetMaintenanceMutationBody = MaintenanceState
    export type SetMaintenanceMutationError = unknown

    export const useSetMaintenance = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof setMaintenance>>, TError,{data: MaintenanceState}, TContext>, request?: SecondParameter<typeof apiFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof setMaintenance>>,
        TError,
        {data: MaintenanceState},
        TContext
      > => {
      return useMutation(getSetMaintenanceMutationOptions(options));
    }
    export const listAdminOrganizations = (
    params?: ListAdminOrganizationsParams,
 options?: SecondParameter<typeof apiFetch>,signal?: AbortSignal
) => {


      return apiFetch<ListAdminOrganizations200>(
      {url: `/admin/organizations`, method: 'GET',
        params, signal
    },
      options);
    }




export const getListAdminOrganizationsQueryKey = (params?: ListAdminOrganizationsParams,) => {
    return [
    `/admin/organizations`, ...(params ? [params] : [])
    ] as const;
    }


export const getListAdminOrganizationsQueryOptions = <TData = Awaited<ReturnType<typeof listAdminOrganizations>>, TError = unknown>(params?: ListAdminOrganizationsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listAdminOrganizations>>, TError, TData>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListAdminOrganizationsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listAdminOrganizations>>> = ({ signal }) => listAdminOrganizations(params, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listAdminOrganizations>>, TError, TData> & { queryKey: QueryKey }
}

export type ListAdminOrganizationsQueryResult = NonNullable<Awaited<ReturnType<typeof listAdminOrganizations>>>
export type ListAdminOrganizationsQueryError = unknown



export function useListAdminOrganizations<TData = Awaited<ReturnType<typeof listAdminOrganizations>>, TError = unknown>(
 params?: ListAdminOrganizationsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listAdminOrganizations>>, TError, TData>, request?: SecondParameter<typeof apiFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListAdminOrganizationsQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}






export const createAdminOrganization = (
    createAdminOrganizationBody: CreateAdminOrganizationBody,
 options?: SecondParameter<typeof apiFetch>,signal?: AbortSignal
) => {


      return apiFetch<Organization>(
      {url: `/admin/organizations`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: createAdminOrganizationBody, signal
    },
      options);
    }




export const getCreateAdminOrganizationMutationOptions = <TError = ErrorEnvelope,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createAdminOrganization>>, TError,{data: CreateAdminOrganizationBody}, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createAdminOrganization>>, TError,{data: CreateAdminOrganizationBody}, TContext> => {

const mutationKey = ['createAdminOrganization'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createAdminOrganization>>, {data: CreateAdminOrganizationBody}> = (props) => {
          const {data} = props ?? {};

          return  createAdminOrganization(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateAdminOrganizationMutationResult = NonNullable<Awaited<ReturnType<typeof createAdminOrganization>>>
    export type CreateAdminOrganizationMutationBody = CreateAdminOrganizationBody
    export type CreateAdminOrganizationMutationError = ErrorEnvelope

    export const useCreateAdminOrganization = <TError = ErrorEnvelope,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createAdminOrganization>>, TError,{data: CreateAdminOrganizationBody}, TContext>, request?: SecondParameter<typeof apiFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof createAdminOrganization>>,
        TError,
        {data: CreateAdminOrganizationBody},
        TContext
      > => {
      return useMutation(getCreateAdminOrganizationMutationOptions(options));
    }
    export const deleteAdminOrganization = (
    id: string,
 options?: SecondParameter<typeof apiFetch>,signal?: AbortSignal
) => {


      return apiFetch<void>(
      {url: `/admin/organizations/${encodeURIComponent(String(id))}`, method: 'DELETE', signal
    },
      options);
    }




export const getDeleteAdminOrganizationMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteAdminOrganization>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteAdminOrganization>>, TError,{id: string}, TContext> => {

const mutationKey = ['deleteAdminOrganization'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteAdminOrganization>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  deleteAdminOrganization(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteAdminOrganizationMutationResult = NonNullable<Awaited<ReturnType<typeof deleteAdminOrganization>>>

    export type DeleteAdminOrganizationMutationError = unknown

    export const useDeleteAdminOrganization = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteAdminOrganization>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof apiFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof deleteAdminOrganization>>,
        TError,
        {id: string},
        TContext
      > => {
      return useMutation(getDeleteAdminOrganizationMutationOptions(options));
    }
    /**
 * @summary Get the billing entity that owns an organization, and that billing entity's organizations.
 */
export const getAdminOrganizationBillingEntity = (
    id: string,
 options?: SecondParameter<typeof apiFetch>,signal?: AbortSignal
) => {


      return apiFetch<AdminOrganizationBillingEntity>(
      {url: `/admin/organizations/${encodeURIComponent(String(id))}/billing-entity`, method: 'GET', signal
    },
      options);
    }




export const getGetAdminOrganizationBillingEntityQueryKey = (id: string,) => {
    return [
    `/admin/organizations/${id}/billing-entity`
    ] as const;
    }


export const getGetAdminOrganizationBillingEntityQueryOptions = <TData = Awaited<ReturnType<typeof getAdminOrganizationBillingEntity>>, TError = unknown>(id: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getAdminOrganizationBillingEntity>>, TError, TData>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAdminOrganizationBillingEntityQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAdminOrganizationBillingEntity>>> = ({ signal }) => getAdminOrganizationBillingEntity(id, requestOptions, signal);





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAdminOrganizationBillingEntity>>, TError, TData> & { queryKey: QueryKey }
}

export type GetAdminOrganizationBillingEntityQueryResult = NonNullable<Awaited<ReturnType<typeof getAdminOrganizationBillingEntity>>>
export type GetAdminOrganizationBillingEntityQueryError = unknown


/**
 * @summary Get the billing entity that owns an organization, and that billing entity's organizations.
 */

export function useGetAdminOrganizationBillingEntity<TData = Awaited<ReturnType<typeof getAdminOrganizationBillingEntity>>, TError = unknown>(
 id: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getAdminOrganizationBillingEntity>>, TError, TData>, request?: SecondParameter<typeof apiFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetAdminOrganizationBillingEntityQueryOptions(id,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}






export const setAdminOrganizationBillingEntity = (
    id: string,
    setAdminOrganizationBillingEntityBody: SetAdminOrganizationBillingEntityBody,
 options?: SecondParameter<typeof apiFetch>,signal?: AbortSignal
) => {


      return apiFetch<AdminOrganizationBillingEntityMoveResult>(
      {url: `/admin/organizations/${encodeURIComponent(String(id))}/billing-entity`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: setAdminOrganizationBillingEntityBody, signal
    },
      options);
    }




export const getSetAdminOrganizationBillingEntityMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof setAdminOrganizationBillingEntity>>, TError,{id: string;data: SetAdminOrganizationBillingEntityBody}, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof setAdminOrganizationBillingEntity>>, TError,{id: string;data: SetAdminOrganizationBillingEntityBody}, TContext> => {

const mutationKey = ['setAdminOrganizationBillingEntity'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof setAdminOrganizationBillingEntity>>, {id: string;data: SetAdminOrganizationBillingEntityBody}> = (props) => {
          const {id,data} = props ?? {};

          return  setAdminOrganizationBillingEntity(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type SetAdminOrganizationBillingEntityMutationResult = NonNullable<Awaited<ReturnType<typeof setAdminOrganizationBillingEntity>>>
    export type SetAdminOrganizationBillingEntityMutationBody = SetAdminOrganizationBillingEntityBody
    export type SetAdminOrganizationBillingEntityMutationError = unknown

    export const useSetAdminOrganizationBillingEntity = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof setAdminOrganizationBillingEntity>>, TError,{id: string;data: SetAdminOrganizationBillingEntityBody}, TContext>, request?: SecondParameter<typeof apiFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof setAdminOrganizationBillingEntity>>,
        TError,
        {id: string;data: SetAdminOrganizationBillingEntityBody},
        TContext
      > => {
      return useMutation(getSetAdminOrganizationBillingEntityMutationOptions(options));
    }
    export const setAdminOrganizationCapabilities = (
    id: string,
    setAdminOrganizationCapabilitiesBody: SetAdminOrganizationCapabilitiesBody,
 options?: SecondParameter<typeof apiFetch>,signal?: AbortSignal
) => {


      return apiFetch<Organization>(
      {url: `/admin/organizations/${encodeURIComponent(String(id))}/capabilities`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: setAdminOrganizationCapabilitiesBody, signal
    },
      options);
    }




export const getSetAdminOrganizationCapabilitiesMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof setAdminOrganizationCapabilities>>, TError,{id: string;data: SetAdminOrganizationCapabilitiesBody}, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof setAdminOrganizationCapabilities>>, TError,{id: string;data: SetAdminOrganizationCapabilitiesBody}, TContext> => {

const mutationKey = ['setAdminOrganizationCapabilities'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof setAdminOrganizationCapabilities>>, {id: string;data: SetAdminOrganizationCapabilitiesBody}> = (props) => {
          const {id,data} = props ?? {};

          return  setAdminOrganizationCapabilities(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type SetAdminOrganizationCapabilitiesMutationResult = NonNullable<Awaited<ReturnType<typeof setAdminOrganizationCapabilities>>>
    export type SetAdminOrganizationCapabilitiesMutationBody = SetAdminOrganizationCapabilitiesBody
    export type SetAdminOrganizationCapabilitiesMutationError = unknown

    export const useSetAdminOrganizationCapabilities = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof setAdminOrganizationCapabilities>>, TError,{id: string;data: SetAdminOrganizationCapabilitiesBody}, TContext>, request?: SecondParameter<typeof apiFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof setAdminOrganizationCapabilities>>,
        TError,
        {id: string;data: SetAdminOrganizationCapabilitiesBody},
        TContext
      > => {
      return useMutation(getSetAdminOrganizationCapabilitiesMutationOptions(options));
    }
    export const setAdminOrganizationCapability = (
    id: string,
    setAdminOrganizationCapabilityBody: SetAdminOrganizationCapabilityBody,
 options?: SecondParameter<typeof apiFetch>,signal?: AbortSignal
) => {


      return apiFetch<Organization>(
      {url: `/admin/organizations/${encodeURIComponent(String(id))}/capability`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: setAdminOrganizationCapabilityBody, signal
    },
      options);
    }




export const getSetAdminOrganizationCapabilityMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof setAdminOrganizationCapability>>, TError,{id: string;data: SetAdminOrganizationCapabilityBody}, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof setAdminOrganizationCapability>>, TError,{id: string;data: SetAdminOrganizationCapabilityBody}, TContext> => {

const mutationKey = ['setAdminOrganizationCapability'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof setAdminOrganizationCapability>>, {id: string;data: SetAdminOrganizationCapabilityBody}> = (props) => {
          const {id,data} = props ?? {};

          return  setAdminOrganizationCapability(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type SetAdminOrganizationCapabilityMutationResult = NonNullable<Awaited<ReturnType<typeof setAdminOrganizationCapability>>>
    export type SetAdminOrganizationCapabilityMutationBody = SetAdminOrganizationCapabilityBody
    export type SetAdminOrganizationCapabilityMutationError = unknown

    export const useSetAdminOrganizationCapability = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof setAdminOrganizationCapability>>, TError,{id: string;data: SetAdminOrganizationCapabilityBody}, TContext>, request?: SecondParameter<typeof apiFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof setAdminOrganizationCapability>>,
        TError,
        {id: string;data: SetAdminOrganizationCapabilityBody},
        TContext
      > => {
      return useMutation(getSetAdminOrganizationCapabilityMutationOptions(options));
    }
    export const setAdminOrganizationSubscriptionTier = (
    id: string,
    setAdminOrganizationSubscriptionTierBody: SetAdminOrganizationSubscriptionTierBody,
 options?: SecondParameter<typeof apiFetch>,signal?: AbortSignal
) => {


      return apiFetch<Organization>(
      {url: `/admin/organizations/${encodeURIComponent(String(id))}/subscription-tier`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: setAdminOrganizationSubscriptionTierBody, signal
    },
      options);
    }




export const getSetAdminOrganizationSubscriptionTierMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof setAdminOrganizationSubscriptionTier>>, TError,{id: string;data: SetAdminOrganizationSubscriptionTierBody}, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof setAdminOrganizationSubscriptionTier>>, TError,{id: string;data: SetAdminOrganizationSubscriptionTierBody}, TContext> => {

const mutationKey = ['setAdminOrganizationSubscriptionTier'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof setAdminOrganizationSubscriptionTier>>, {id: string;data: SetAdminOrganizationSubscriptionTierBody}> = (props) => {
          const {id,data} = props ?? {};

          return  setAdminOrganizationSubscriptionTier(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type SetAdminOrganizationSubscriptionTierMutationResult = NonNullable<Awaited<ReturnType<typeof setAdminOrganizationSubscriptionTier>>>
    export type SetAdminOrganizationSubscriptionTierMutationBody = SetAdminOrganizationSubscriptionTierBody
    export type SetAdminOrganizationSubscriptionTierMutationError = unknown

    export const useSetAdminOrganizationSubscriptionTier = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof setAdminOrganizationSubscriptionTier>>, TError,{id: string;data: SetAdminOrganizationSubscriptionTierBody}, TContext>, request?: SecondParameter<typeof apiFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof setAdminOrganizationSubscriptionTier>>,
        TError,
        {id: string;data: SetAdminOrganizationSubscriptionTierBody},
        TContext
      > => {
      return useMutation(getSetAdminOrganizationSubscriptionTierMutationOptions(options));
    }
    export const getAdminOrganizationActivity = (
    organizationId: string,
 options?: SecondParameter<typeof apiFetch>,signal?: AbortSignal
) => {


      return apiFetch<OrgActivitySummary>(
      {url: `/admin/organizations/${encodeURIComponent(String(organizationId))}/activity`, method: 'GET', signal
    },
      options);
    }




export const getGetAdminOrganizationActivityQueryKey = (organizationId: string,) => {
    return [
    `/admin/organizations/${organizationId}/activity`
    ] as const;
    }


export const getGetAdminOrganizationActivityQueryOptions = <TData = Awaited<ReturnType<typeof getAdminOrganizationActivity>>, TError = unknown>(organizationId: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getAdminOrganizationActivity>>, TError, TData>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAdminOrganizationActivityQueryKey(organizationId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAdminOrganizationActivity>>> = ({ signal }) => getAdminOrganizationActivity(organizationId, requestOptions, signal);





   return  { queryKey, queryFn, enabled: organizationId !== null && organizationId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAdminOrganizationActivity>>, TError, TData> & { queryKey: QueryKey }
}

export type GetAdminOrganizationActivityQueryResult = NonNullable<Awaited<ReturnType<typeof getAdminOrganizationActivity>>>
export type GetAdminOrganizationActivityQueryError = unknown



export function useGetAdminOrganizationActivity<TData = Awaited<ReturnType<typeof getAdminOrganizationActivity>>, TError = unknown>(
 organizationId: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getAdminOrganizationActivity>>, TError, TData>, request?: SecondParameter<typeof apiFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetAdminOrganizationActivityQueryOptions(organizationId,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * @summary Get an organization's enterprise identity entitlement and setup status.
 */
export const getAdminEnterpriseIdentityStatus = (
    organizationId: string,
 options?: SecondParameter<typeof apiFetch>,signal?: AbortSignal
) => {


      return apiFetch<AdminEnterpriseIdentityStatus>(
      {url: `/admin/organizations/${encodeURIComponent(String(organizationId))}/enterprise-identity`, method: 'GET', signal
    },
      options);
    }




export const getGetAdminEnterpriseIdentityStatusQueryKey = (organizationId: string,) => {
    return [
    `/admin/organizations/${organizationId}/enterprise-identity`
    ] as const;
    }


export const getGetAdminEnterpriseIdentityStatusQueryOptions = <TData = Awaited<ReturnType<typeof getAdminEnterpriseIdentityStatus>>, TError = unknown>(organizationId: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getAdminEnterpriseIdentityStatus>>, TError, TData>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAdminEnterpriseIdentityStatusQueryKey(organizationId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAdminEnterpriseIdentityStatus>>> = ({ signal }) => getAdminEnterpriseIdentityStatus(organizationId, requestOptions, signal);





   return  { queryKey, queryFn, enabled: organizationId !== null && organizationId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAdminEnterpriseIdentityStatus>>, TError, TData> & { queryKey: QueryKey }
}

export type GetAdminEnterpriseIdentityStatusQueryResult = NonNullable<Awaited<ReturnType<typeof getAdminEnterpriseIdentityStatus>>>
export type GetAdminEnterpriseIdentityStatusQueryError = unknown


/**
 * @summary Get an organization's enterprise identity entitlement and setup status.
 */

export function useGetAdminEnterpriseIdentityStatus<TData = Awaited<ReturnType<typeof getAdminEnterpriseIdentityStatus>>, TError = unknown>(
 organizationId: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getAdminEnterpriseIdentityStatus>>, TError, TData>, request?: SecondParameter<typeof apiFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetAdminEnterpriseIdentityStatusQueryOptions(organizationId,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}






export const setAdminOrganizationStatus = (
    organizationId: string,
    setAdminOrganizationStatusBody: SetAdminOrganizationStatusBody,
 options?: SecondParameter<typeof apiFetch>,signal?: AbortSignal
) => {


      return apiFetch<AdminOkResponse>(
      {url: `/admin/organizations/${encodeURIComponent(String(organizationId))}/status`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: setAdminOrganizationStatusBody, signal
    },
      options);
    }




export const getSetAdminOrganizationStatusMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof setAdminOrganizationStatus>>, TError,{organizationId: string;data: SetAdminOrganizationStatusBody}, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof setAdminOrganizationStatus>>, TError,{organizationId: string;data: SetAdminOrganizationStatusBody}, TContext> => {

const mutationKey = ['setAdminOrganizationStatus'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof setAdminOrganizationStatus>>, {organizationId: string;data: SetAdminOrganizationStatusBody}> = (props) => {
          const {organizationId,data} = props ?? {};

          return  setAdminOrganizationStatus(organizationId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type SetAdminOrganizationStatusMutationResult = NonNullable<Awaited<ReturnType<typeof setAdminOrganizationStatus>>>
    export type SetAdminOrganizationStatusMutationBody = SetAdminOrganizationStatusBody
    export type SetAdminOrganizationStatusMutationError = unknown

    export const useSetAdminOrganizationStatus = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof setAdminOrganizationStatus>>, TError,{organizationId: string;data: SetAdminOrganizationStatusBody}, TContext>, request?: SecondParameter<typeof apiFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof setAdminOrganizationStatus>>,
        TError,
        {organizationId: string;data: SetAdminOrganizationStatusBody},
        TContext
      > => {
      return useMutation(getSetAdminOrganizationStatusMutationOptions(options));
    }
    export const setOrganizationSubscription = (
    organizationId: string,
    setOrganizationSubscriptionBody: SetOrganizationSubscriptionBody,
 options?: SecondParameter<typeof apiFetch>,signal?: AbortSignal
) => {


      return apiFetch<Organization>(
      {url: `/admin/organizations/${encodeURIComponent(String(organizationId))}/subscription`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: setOrganizationSubscriptionBody, signal
    },
      options);
    }




export const getSetOrganizationSubscriptionMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof setOrganizationSubscription>>, TError,{organizationId: string;data: SetOrganizationSubscriptionBody}, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof setOrganizationSubscription>>, TError,{organizationId: string;data: SetOrganizationSubscriptionBody}, TContext> => {

const mutationKey = ['setOrganizationSubscription'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof setOrganizationSubscription>>, {organizationId: string;data: SetOrganizationSubscriptionBody}> = (props) => {
          const {organizationId,data} = props ?? {};

          return  setOrganizationSubscription(organizationId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type SetOrganizationSubscriptionMutationResult = NonNullable<Awaited<ReturnType<typeof setOrganizationSubscription>>>
    export type SetOrganizationSubscriptionMutationBody = SetOrganizationSubscriptionBody
    export type SetOrganizationSubscriptionMutationError = unknown

    export const useSetOrganizationSubscription = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof setOrganizationSubscription>>, TError,{organizationId: string;data: SetOrganizationSubscriptionBody}, TContext>, request?: SecondParameter<typeof apiFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof setOrganizationSubscription>>,
        TError,
        {organizationId: string;data: SetOrganizationSubscriptionBody},
        TContext
      > => {
      return useMutation(getSetOrganizationSubscriptionMutationOptions(options));
    }
    export const expireOrganizationSubscription = (
    organizationId: string,
 options?: SecondParameter<typeof apiFetch>,signal?: AbortSignal
) => {


      return apiFetch<Organization>(
      {url: `/admin/organizations/${encodeURIComponent(String(organizationId))}/subscription/expire`, method: 'POST', signal
    },
      options);
    }




export const getExpireOrganizationSubscriptionMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof expireOrganizationSubscription>>, TError,{organizationId: string}, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof expireOrganizationSubscription>>, TError,{organizationId: string}, TContext> => {

const mutationKey = ['expireOrganizationSubscription'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof expireOrganizationSubscription>>, {organizationId: string}> = (props) => {
          const {organizationId} = props ?? {};

          return  expireOrganizationSubscription(organizationId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ExpireOrganizationSubscriptionMutationResult = NonNullable<Awaited<ReturnType<typeof expireOrganizationSubscription>>>

    export type ExpireOrganizationSubscriptionMutationError = unknown

    export const useExpireOrganizationSubscription = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof expireOrganizationSubscription>>, TError,{organizationId: string}, TContext>, request?: SecondParameter<typeof apiFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof expireOrganizationSubscription>>,
        TError,
        {organizationId: string},
        TContext
      > => {
      return useMutation(getExpireOrganizationSubscriptionMutationOptions(options));
    }
    export const getPluginServiceConfig = (
    name: string,
 options?: SecondParameter<typeof apiFetch>,signal?: AbortSignal
) => {


      return apiFetch<GetPluginServiceConfig200>(
      {url: `/admin/plugins/${encodeURIComponent(String(name))}/service-config`, method: 'GET', signal
    },
      options);
    }




export const getGetPluginServiceConfigQueryKey = (name: string,) => {
    return [
    `/admin/plugins/${name}/service-config`
    ] as const;
    }


export const getGetPluginServiceConfigQueryOptions = <TData = Awaited<ReturnType<typeof getPluginServiceConfig>>, TError = unknown>(name: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getPluginServiceConfig>>, TError, TData>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetPluginServiceConfigQueryKey(name);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getPluginServiceConfig>>> = ({ signal }) => getPluginServiceConfig(name, requestOptions, signal);





   return  { queryKey, queryFn, enabled: name !== null && name !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getPluginServiceConfig>>, TError, TData> & { queryKey: QueryKey }
}

export type GetPluginServiceConfigQueryResult = NonNullable<Awaited<ReturnType<typeof getPluginServiceConfig>>>
export type GetPluginServiceConfigQueryError = unknown



export function useGetPluginServiceConfig<TData = Awaited<ReturnType<typeof getPluginServiceConfig>>, TError = unknown>(
 name: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getPluginServiceConfig>>, TError, TData>, request?: SecondParameter<typeof apiFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetPluginServiceConfigQueryOptions(name,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}






export const updatePluginServiceConfig = (
    name: string,
    updatePluginServiceConfigBody: UpdatePluginServiceConfigBody,
 options?: SecondParameter<typeof apiFetch>,signal?: AbortSignal
) => {


      return apiFetch<UpdatePluginServiceConfig200>(
      {url: `/admin/plugins/${encodeURIComponent(String(name))}/service-config`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: updatePluginServiceConfigBody, signal
    },
      options);
    }




export const getUpdatePluginServiceConfigMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updatePluginServiceConfig>>, TError,{name: string;data: UpdatePluginServiceConfigBody}, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof updatePluginServiceConfig>>, TError,{name: string;data: UpdatePluginServiceConfigBody}, TContext> => {

const mutationKey = ['updatePluginServiceConfig'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updatePluginServiceConfig>>, {name: string;data: UpdatePluginServiceConfigBody}> = (props) => {
          const {name,data} = props ?? {};

          return  updatePluginServiceConfig(name,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdatePluginServiceConfigMutationResult = NonNullable<Awaited<ReturnType<typeof updatePluginServiceConfig>>>
    export type UpdatePluginServiceConfigMutationBody = UpdatePluginServiceConfigBody
    export type UpdatePluginServiceConfigMutationError = unknown

    export const useUpdatePluginServiceConfig = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updatePluginServiceConfig>>, TError,{name: string;data: UpdatePluginServiceConfigBody}, TContext>, request?: SecondParameter<typeof apiFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof updatePluginServiceConfig>>,
        TError,
        {name: string;data: UpdatePluginServiceConfigBody},
        TContext
      > => {
      return useMutation(getUpdatePluginServiceConfigMutationOptions(options));
    }
    export const createProvisionedAdminOrganization = (
    createProvisionedAdminOrganizationBody: CreateProvisionedAdminOrganizationBody,
 options?: SecondParameter<typeof apiFetch>,signal?: AbortSignal
) => {


      return apiFetch<Organization>(
      {url: `/admin/provisioned-organizations`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: createProvisionedAdminOrganizationBody, signal
    },
      options);
    }




export const getCreateProvisionedAdminOrganizationMutationOptions = <TError = ErrorEnvelope,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createProvisionedAdminOrganization>>, TError,{data: CreateProvisionedAdminOrganizationBody}, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createProvisionedAdminOrganization>>, TError,{data: CreateProvisionedAdminOrganizationBody}, TContext> => {

const mutationKey = ['createProvisionedAdminOrganization'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createProvisionedAdminOrganization>>, {data: CreateProvisionedAdminOrganizationBody}> = (props) => {
          const {data} = props ?? {};

          return  createProvisionedAdminOrganization(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateProvisionedAdminOrganizationMutationResult = NonNullable<Awaited<ReturnType<typeof createProvisionedAdminOrganization>>>
    export type CreateProvisionedAdminOrganizationMutationBody = CreateProvisionedAdminOrganizationBody
    export type CreateProvisionedAdminOrganizationMutationError = ErrorEnvelope

    export const useCreateProvisionedAdminOrganization = <TError = ErrorEnvelope,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createProvisionedAdminOrganization>>, TError,{data: CreateProvisionedAdminOrganizationBody}, TContext>, request?: SecondParameter<typeof apiFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof createProvisionedAdminOrganization>>,
        TError,
        {data: CreateProvisionedAdminOrganizationBody},
        TContext
      > => {
      return useMutation(getCreateProvisionedAdminOrganizationMutationOptions(options));
    }
    export const setAdminSecret = (
    name: string,
    setAdminSecretBody: SetAdminSecretBody,
 options?: SecondParameter<typeof apiFetch>,signal?: AbortSignal
) => {


      return apiFetch<SecretMutationResponse>(
      {url: `/admin/secrets/${encodeURIComponent(String(name))}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: setAdminSecretBody, signal
    },
      options);
    }




export const getSetAdminSecretMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof setAdminSecret>>, TError,{name: string;data: SetAdminSecretBody}, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof setAdminSecret>>, TError,{name: string;data: SetAdminSecretBody}, TContext> => {

const mutationKey = ['setAdminSecret'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof setAdminSecret>>, {name: string;data: SetAdminSecretBody}> = (props) => {
          const {name,data} = props ?? {};

          return  setAdminSecret(name,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type SetAdminSecretMutationResult = NonNullable<Awaited<ReturnType<typeof setAdminSecret>>>
    export type SetAdminSecretMutationBody = SetAdminSecretBody
    export type SetAdminSecretMutationError = unknown

    export const useSetAdminSecret = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof setAdminSecret>>, TError,{name: string;data: SetAdminSecretBody}, TContext>, request?: SecondParameter<typeof apiFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof setAdminSecret>>,
        TError,
        {name: string;data: SetAdminSecretBody},
        TContext
      > => {
      return useMutation(getSetAdminSecretMutationOptions(options));
    }
    export const deleteAdminSecret = (
    name: string,
 options?: SecondParameter<typeof apiFetch>,signal?: AbortSignal
) => {


      return apiFetch<AdminOkResponse>(
      {url: `/admin/secrets/${encodeURIComponent(String(name))}`, method: 'DELETE', signal
    },
      options);
    }




export const getDeleteAdminSecretMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteAdminSecret>>, TError,{name: string}, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteAdminSecret>>, TError,{name: string}, TContext> => {

const mutationKey = ['deleteAdminSecret'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteAdminSecret>>, {name: string}> = (props) => {
          const {name} = props ?? {};

          return  deleteAdminSecret(name,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteAdminSecretMutationResult = NonNullable<Awaited<ReturnType<typeof deleteAdminSecret>>>

    export type DeleteAdminSecretMutationError = unknown

    export const useDeleteAdminSecret = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteAdminSecret>>, TError,{name: string}, TContext>, request?: SecondParameter<typeof apiFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof deleteAdminSecret>>,
        TError,
        {name: string},
        TContext
      > => {
      return useMutation(getDeleteAdminSecretMutationOptions(options));
    }
    export const getSecretManagerStatus = (

 options?: SecondParameter<typeof apiFetch>,signal?: AbortSignal
) => {


      return apiFetch<GetSecretManagerStatus200>(
      {url: `/admin/secrets/manager`, method: 'GET', signal
    },
      options);
    }




export const getGetSecretManagerStatusQueryKey = () => {
    return [
    `/admin/secrets/manager`
    ] as const;
    }


export const getGetSecretManagerStatusQueryOptions = <TData = Awaited<ReturnType<typeof getSecretManagerStatus>>, TError = unknown>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getSecretManagerStatus>>, TError, TData>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetSecretManagerStatusQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getSecretManagerStatus>>> = ({ signal }) => getSecretManagerStatus(requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getSecretManagerStatus>>, TError, TData> & { queryKey: QueryKey }
}

export type GetSecretManagerStatusQueryResult = NonNullable<Awaited<ReturnType<typeof getSecretManagerStatus>>>
export type GetSecretManagerStatusQueryError = unknown



export function useGetSecretManagerStatus<TData = Awaited<ReturnType<typeof getSecretManagerStatus>>, TError = unknown>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getSecretManagerStatus>>, TError, TData>, request?: SecondParameter<typeof apiFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetSecretManagerStatusQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getAdminSecretsRegistry = (

 options?: SecondParameter<typeof apiFetch>,signal?: AbortSignal
) => {


      return apiFetch<GetAdminSecretsRegistry200Item[]>(
      {url: `/admin/secrets/registry`, method: 'GET', signal
    },
      options);
    }




export const getGetAdminSecretsRegistryQueryKey = () => {
    return [
    `/admin/secrets/registry`
    ] as const;
    }


export const getGetAdminSecretsRegistryQueryOptions = <TData = Awaited<ReturnType<typeof getAdminSecretsRegistry>>, TError = unknown>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getAdminSecretsRegistry>>, TError, TData>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAdminSecretsRegistryQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAdminSecretsRegistry>>> = ({ signal }) => getAdminSecretsRegistry(requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAdminSecretsRegistry>>, TError, TData> & { queryKey: QueryKey }
}

export type GetAdminSecretsRegistryQueryResult = NonNullable<Awaited<ReturnType<typeof getAdminSecretsRegistry>>>
export type GetAdminSecretsRegistryQueryError = unknown



export function useGetAdminSecretsRegistry<TData = Awaited<ReturnType<typeof getAdminSecretsRegistry>>, TError = unknown>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getAdminSecretsRegistry>>, TError, TData>, request?: SecondParameter<typeof apiFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetAdminSecretsRegistryQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}






export const rotateSecrets = (
    rotateSecretsBody: RotateSecretsBody,
 options?: SecondParameter<typeof apiFetch>,signal?: AbortSignal
) => {


      return apiFetch<RotateSecrets200>(
      {url: `/admin/secrets/rotate`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: rotateSecretsBody, signal
    },
      options);
    }




export const getRotateSecretsMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof rotateSecrets>>, TError,{data: RotateSecretsBody}, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof rotateSecrets>>, TError,{data: RotateSecretsBody}, TContext> => {

const mutationKey = ['rotateSecrets'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof rotateSecrets>>, {data: RotateSecretsBody}> = (props) => {
          const {data} = props ?? {};

          return  rotateSecrets(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type RotateSecretsMutationResult = NonNullable<Awaited<ReturnType<typeof rotateSecrets>>>
    export type RotateSecretsMutationBody = RotateSecretsBody
    export type RotateSecretsMutationError = unknown

    export const useRotateSecrets = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof rotateSecrets>>, TError,{data: RotateSecretsBody}, TContext>, request?: SecondParameter<typeof apiFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof rotateSecrets>>,
        TError,
        {data: RotateSecretsBody},
        TContext
      > => {
      return useMutation(getRotateSecretsMutationOptions(options));
    }
    export const getAdminSecretsStatus = (

 options?: SecondParameter<typeof apiFetch>,signal?: AbortSignal
) => {


      return apiFetch<GetAdminSecretsStatus200>(
      {url: `/admin/secrets/status`, method: 'GET', signal
    },
      options);
    }




export const getGetAdminSecretsStatusQueryKey = () => {
    return [
    `/admin/secrets/status`
    ] as const;
    }


export const getGetAdminSecretsStatusQueryOptions = <TData = Awaited<ReturnType<typeof getAdminSecretsStatus>>, TError = unknown>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getAdminSecretsStatus>>, TError, TData>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAdminSecretsStatusQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAdminSecretsStatus>>> = ({ signal }) => getAdminSecretsStatus(requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAdminSecretsStatus>>, TError, TData> & { queryKey: QueryKey }
}

export type GetAdminSecretsStatusQueryResult = NonNullable<Awaited<ReturnType<typeof getAdminSecretsStatus>>>
export type GetAdminSecretsStatusQueryError = unknown



export function useGetAdminSecretsStatus<TData = Awaited<ReturnType<typeof getAdminSecretsStatus>>, TError = unknown>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getAdminSecretsStatus>>, TError, TData>, request?: SecondParameter<typeof apiFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetAdminSecretsStatusQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}






export const setServiceSecret = (
    name: string,
    setServiceSecretBody: SetServiceSecretBody,
 options?: SecondParameter<typeof apiFetch>,signal?: AbortSignal
) => {


      return apiFetch<SetServiceSecret200>(
      {url: `/admin/service-secrets/${encodeURIComponent(String(name))}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: setServiceSecretBody, signal
    },
      options);
    }




export const getSetServiceSecretMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof setServiceSecret>>, TError,{name: string;data: SetServiceSecretBody}, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof setServiceSecret>>, TError,{name: string;data: SetServiceSecretBody}, TContext> => {

const mutationKey = ['setServiceSecret'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof setServiceSecret>>, {name: string;data: SetServiceSecretBody}> = (props) => {
          const {name,data} = props ?? {};

          return  setServiceSecret(name,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type SetServiceSecretMutationResult = NonNullable<Awaited<ReturnType<typeof setServiceSecret>>>
    export type SetServiceSecretMutationBody = SetServiceSecretBody
    export type SetServiceSecretMutationError = unknown

    export const useSetServiceSecret = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof setServiceSecret>>, TError,{name: string;data: SetServiceSecretBody}, TContext>, request?: SecondParameter<typeof apiFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof setServiceSecret>>,
        TError,
        {name: string;data: SetServiceSecretBody},
        TContext
      > => {
      return useMutation(getSetServiceSecretMutationOptions(options));
    }
    export const deleteServiceSecret = (
    name: string,
 options?: SecondParameter<typeof apiFetch>,signal?: AbortSignal
) => {


      return apiFetch<DeleteServiceSecret200>(
      {url: `/admin/service-secrets/${encodeURIComponent(String(name))}`, method: 'DELETE', signal
    },
      options);
    }




export const getDeleteServiceSecretMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteServiceSecret>>, TError,{name: string}, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteServiceSecret>>, TError,{name: string}, TContext> => {

const mutationKey = ['deleteServiceSecret'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteServiceSecret>>, {name: string}> = (props) => {
          const {name} = props ?? {};

          return  deleteServiceSecret(name,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteServiceSecretMutationResult = NonNullable<Awaited<ReturnType<typeof deleteServiceSecret>>>

    export type DeleteServiceSecretMutationError = unknown

    export const useDeleteServiceSecret = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteServiceSecret>>, TError,{name: string}, TContext>, request?: SecondParameter<typeof apiFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof deleteServiceSecret>>,
        TError,
        {name: string},
        TContext
      > => {
      return useMutation(getDeleteServiceSecretMutationOptions(options));
    }
    export const getServiceSecretRegistry = (

 options?: SecondParameter<typeof apiFetch>,signal?: AbortSignal
) => {


      return apiFetch<GetServiceSecretRegistry200Item[]>(
      {url: `/admin/service-secrets/registry`, method: 'GET', signal
    },
      options);
    }




export const getGetServiceSecretRegistryQueryKey = () => {
    return [
    `/admin/service-secrets/registry`
    ] as const;
    }


export const getGetServiceSecretRegistryQueryOptions = <TData = Awaited<ReturnType<typeof getServiceSecretRegistry>>, TError = unknown>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getServiceSecretRegistry>>, TError, TData>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetServiceSecretRegistryQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getServiceSecretRegistry>>> = ({ signal }) => getServiceSecretRegistry(requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getServiceSecretRegistry>>, TError, TData> & { queryKey: QueryKey }
}

export type GetServiceSecretRegistryQueryResult = NonNullable<Awaited<ReturnType<typeof getServiceSecretRegistry>>>
export type GetServiceSecretRegistryQueryError = unknown



export function useGetServiceSecretRegistry<TData = Awaited<ReturnType<typeof getServiceSecretRegistry>>, TError = unknown>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getServiceSecretRegistry>>, TError, TData>, request?: SecondParameter<typeof apiFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetServiceSecretRegistryQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getServiceSettings = (

 options?: SecondParameter<typeof apiFetch>,signal?: AbortSignal
) => {


      return apiFetch<ServiceSettings>(
      {url: `/admin/service-settings`, method: 'GET', signal
    },
      options);
    }




export const getGetServiceSettingsQueryKey = () => {
    return [
    `/admin/service-settings`
    ] as const;
    }


export const getGetServiceSettingsQueryOptions = <TData = Awaited<ReturnType<typeof getServiceSettings>>, TError = unknown>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getServiceSettings>>, TError, TData>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetServiceSettingsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getServiceSettings>>> = ({ signal }) => getServiceSettings(requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getServiceSettings>>, TError, TData> & { queryKey: QueryKey }
}

export type GetServiceSettingsQueryResult = NonNullable<Awaited<ReturnType<typeof getServiceSettings>>>
export type GetServiceSettingsQueryError = unknown



export function useGetServiceSettings<TData = Awaited<ReturnType<typeof getServiceSettings>>, TError = unknown>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getServiceSettings>>, TError, TData>, request?: SecondParameter<typeof apiFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetServiceSettingsQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}






export const updateServiceSettings = (
    serviceSettings: ServiceSettings,
 options?: SecondParameter<typeof apiFetch>,signal?: AbortSignal
) => {


      return apiFetch<ServiceSettings>(
      {url: `/admin/service-settings`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: serviceSettings, signal
    },
      options);
    }




export const getUpdateServiceSettingsMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateServiceSettings>>, TError,{data: ServiceSettings}, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof updateServiceSettings>>, TError,{data: ServiceSettings}, TContext> => {

const mutationKey = ['updateServiceSettings'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateServiceSettings>>, {data: ServiceSettings}> = (props) => {
          const {data} = props ?? {};

          return  updateServiceSettings(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateServiceSettingsMutationResult = NonNullable<Awaited<ReturnType<typeof updateServiceSettings>>>
    export type UpdateServiceSettingsMutationBody = ServiceSettings
    export type UpdateServiceSettingsMutationError = unknown

    export const useUpdateServiceSettings = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateServiceSettings>>, TError,{data: ServiceSettings}, TContext>, request?: SecondParameter<typeof apiFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof updateServiceSettings>>,
        TError,
        {data: ServiceSettings},
        TContext
      > => {
      return useMutation(getUpdateServiceSettingsMutationOptions(options));
    }
    export const getAdminStatus = (

 options?: SecondParameter<typeof apiFetch>,signal?: AbortSignal
) => {


      return apiFetch<GetAdminStatus200>(
      {url: `/admin/status`, method: 'GET', signal
    },
      options);
    }




export const getGetAdminStatusQueryKey = () => {
    return [
    `/admin/status`
    ] as const;
    }


export const getGetAdminStatusQueryOptions = <TData = Awaited<ReturnType<typeof getAdminStatus>>, TError = unknown>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getAdminStatus>>, TError, TData>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAdminStatusQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAdminStatus>>> = ({ signal }) => getAdminStatus(requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAdminStatus>>, TError, TData> & { queryKey: QueryKey }
}

export type GetAdminStatusQueryResult = NonNullable<Awaited<ReturnType<typeof getAdminStatus>>>
export type GetAdminStatusQueryError = unknown



export function useGetAdminStatus<TData = Awaited<ReturnType<typeof getAdminStatus>>, TError = unknown>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getAdminStatus>>, TError, TData>, request?: SecondParameter<typeof apiFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetAdminStatusQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}






export const listAdminUsers = (
    params?: ListAdminUsersParams,
 options?: SecondParameter<typeof apiFetch>,signal?: AbortSignal
) => {


      return apiFetch<ListAdminUsers200>(
      {url: `/admin/users`, method: 'GET',
        params, signal
    },
      options);
    }




export const getListAdminUsersQueryKey = (params?: ListAdminUsersParams,) => {
    return [
    `/admin/users`, ...(params ? [params] : [])
    ] as const;
    }


export const getListAdminUsersQueryOptions = <TData = Awaited<ReturnType<typeof listAdminUsers>>, TError = unknown>(params?: ListAdminUsersParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listAdminUsers>>, TError, TData>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListAdminUsersQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listAdminUsers>>> = ({ signal }) => listAdminUsers(params, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listAdminUsers>>, TError, TData> & { queryKey: QueryKey }
}

export type ListAdminUsersQueryResult = NonNullable<Awaited<ReturnType<typeof listAdminUsers>>>
export type ListAdminUsersQueryError = unknown



export function useListAdminUsers<TData = Awaited<ReturnType<typeof listAdminUsers>>, TError = unknown>(
 params?: ListAdminUsersParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listAdminUsers>>, TError, TData>, request?: SecondParameter<typeof apiFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListAdminUsersQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getAdminUser = (
    id: string,
 options?: SecondParameter<typeof apiFetch>,signal?: AbortSignal
) => {


      return apiFetch<User>(
      {url: `/admin/users/${encodeURIComponent(String(id))}`, method: 'GET', signal
    },
      options);
    }




export const getGetAdminUserQueryKey = (id: string,) => {
    return [
    `/admin/users/${id}`
    ] as const;
    }


export const getGetAdminUserQueryOptions = <TData = Awaited<ReturnType<typeof getAdminUser>>, TError = unknown>(id: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getAdminUser>>, TError, TData>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAdminUserQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAdminUser>>> = ({ signal }) => getAdminUser(id, requestOptions, signal);





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAdminUser>>, TError, TData> & { queryKey: QueryKey }
}

export type GetAdminUserQueryResult = NonNullable<Awaited<ReturnType<typeof getAdminUser>>>
export type GetAdminUserQueryError = unknown



export function useGetAdminUser<TData = Awaited<ReturnType<typeof getAdminUser>>, TError = unknown>(
 id: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getAdminUser>>, TError, TData>, request?: SecondParameter<typeof apiFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetAdminUserQueryOptions(id,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getAdminUserProviders = (
    id: string,
 options?: SecondParameter<typeof apiFetch>,signal?: AbortSignal
) => {


      return apiFetch<ProviderAccount[]>(
      {url: `/admin/users/${encodeURIComponent(String(id))}/providers`, method: 'GET', signal
    },
      options);
    }




export const getGetAdminUserProvidersQueryKey = (id: string,) => {
    return [
    `/admin/users/${id}/providers`
    ] as const;
    }


export const getGetAdminUserProvidersQueryOptions = <TData = Awaited<ReturnType<typeof getAdminUserProviders>>, TError = unknown>(id: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getAdminUserProviders>>, TError, TData>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAdminUserProvidersQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAdminUserProviders>>> = ({ signal }) => getAdminUserProviders(id, requestOptions, signal);





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAdminUserProviders>>, TError, TData> & { queryKey: QueryKey }
}

export type GetAdminUserProvidersQueryResult = NonNullable<Awaited<ReturnType<typeof getAdminUserProviders>>>
export type GetAdminUserProvidersQueryError = unknown



export function useGetAdminUserProviders<TData = Awaited<ReturnType<typeof getAdminUserProviders>>, TError = unknown>(
 id: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getAdminUserProviders>>, TError, TData>, request?: SecondParameter<typeof apiFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetAdminUserProvidersQueryOptions(id,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * @summary Erase an account’s profile, credentials, and access.
 */
export const eraseAdminUser = (
    userId: string,
    eraseAdminUserBody: EraseAdminUserBody,
 options?: SecondParameter<typeof apiFetch>,signal?: AbortSignal
) => {


      return apiFetch<EraseAdminUser200>(
      {url: `/admin/users/${encodeURIComponent(String(userId))}/erase`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: eraseAdminUserBody, signal
    },
      options);
    }




export const getEraseAdminUserMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof eraseAdminUser>>, TError,{userId: string;data: EraseAdminUserBody}, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof eraseAdminUser>>, TError,{userId: string;data: EraseAdminUserBody}, TContext> => {

const mutationKey = ['eraseAdminUser'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof eraseAdminUser>>, {userId: string;data: EraseAdminUserBody}> = (props) => {
          const {userId,data} = props ?? {};

          return  eraseAdminUser(userId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type EraseAdminUserMutationResult = NonNullable<Awaited<ReturnType<typeof eraseAdminUser>>>
    export type EraseAdminUserMutationBody = EraseAdminUserBody
    export type EraseAdminUserMutationError = unknown

    /**
 * @summary Erase an account’s profile, credentials, and access.
 */
export const useEraseAdminUser = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof eraseAdminUser>>, TError,{userId: string;data: EraseAdminUserBody}, TContext>, request?: SecondParameter<typeof apiFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof eraseAdminUser>>,
        TError,
        {userId: string;data: EraseAdminUserBody},
        TContext
      > => {
      return useMutation(getEraseAdminUserMutationOptions(options));
    }
    export const getAdminUserErasure = (
    userId: string,
 options?: SecondParameter<typeof apiFetch>,signal?: AbortSignal
) => {


      return apiFetch<GetAdminUserErasure200>(
      {url: `/admin/users/${encodeURIComponent(String(userId))}/erasure`, method: 'GET', signal
    },
      options);
    }




export const getGetAdminUserErasureQueryKey = (userId: string,) => {
    return [
    `/admin/users/${userId}/erasure`
    ] as const;
    }


export const getGetAdminUserErasureQueryOptions = <TData = Awaited<ReturnType<typeof getAdminUserErasure>>, TError = unknown>(userId: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getAdminUserErasure>>, TError, TData>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAdminUserErasureQueryKey(userId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAdminUserErasure>>> = ({ signal }) => getAdminUserErasure(userId, requestOptions, signal);





   return  { queryKey, queryFn, enabled: userId !== null && userId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAdminUserErasure>>, TError, TData> & { queryKey: QueryKey }
}

export type GetAdminUserErasureQueryResult = NonNullable<Awaited<ReturnType<typeof getAdminUserErasure>>>
export type GetAdminUserErasureQueryError = unknown



export function useGetAdminUserErasure<TData = Awaited<ReturnType<typeof getAdminUserErasure>>, TError = unknown>(
 userId: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getAdminUserErasure>>, TError, TData>, request?: SecondParameter<typeof apiFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetAdminUserErasureQueryOptions(userId,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * @summary Record completion of the external erasure review.
 */
export const reviewAdminUserErasure = (
    userId: string,
    reviewAdminUserErasureBody: ReviewAdminUserErasureBody,
 options?: SecondParameter<typeof apiFetch>,signal?: AbortSignal
) => {


      return apiFetch<ReviewAdminUserErasure200>(
      {url: `/admin/users/${encodeURIComponent(String(userId))}/erasure/review`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: reviewAdminUserErasureBody, signal
    },
      options);
    }




export const getReviewAdminUserErasureMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof reviewAdminUserErasure>>, TError,{userId: string;data: ReviewAdminUserErasureBody}, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof reviewAdminUserErasure>>, TError,{userId: string;data: ReviewAdminUserErasureBody}, TContext> => {

const mutationKey = ['reviewAdminUserErasure'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof reviewAdminUserErasure>>, {userId: string;data: ReviewAdminUserErasureBody}> = (props) => {
          const {userId,data} = props ?? {};

          return  reviewAdminUserErasure(userId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ReviewAdminUserErasureMutationResult = NonNullable<Awaited<ReturnType<typeof reviewAdminUserErasure>>>
    export type ReviewAdminUserErasureMutationBody = ReviewAdminUserErasureBody
    export type ReviewAdminUserErasureMutationError = unknown

    /**
 * @summary Record completion of the external erasure review.
 */
export const useReviewAdminUserErasure = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof reviewAdminUserErasure>>, TError,{userId: string;data: ReviewAdminUserErasureBody}, TContext>, request?: SecondParameter<typeof apiFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof reviewAdminUserErasure>>,
        TError,
        {userId: string;data: ReviewAdminUserErasureBody},
        TContext
      > => {
      return useMutation(getReviewAdminUserErasureMutationOptions(options));
    }
    export const getAdminUserOrganizations = (
    userId: string,
 options?: SecondParameter<typeof apiFetch>,signal?: AbortSignal
) => {


      return apiFetch<GetAdminUserOrganizations200>(
      {url: `/admin/users/${encodeURIComponent(String(userId))}/organizations`, method: 'GET', signal
    },
      options);
    }




export const getGetAdminUserOrganizationsQueryKey = (userId: string,) => {
    return [
    `/admin/users/${userId}/organizations`
    ] as const;
    }


export const getGetAdminUserOrganizationsQueryOptions = <TData = Awaited<ReturnType<typeof getAdminUserOrganizations>>, TError = unknown>(userId: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getAdminUserOrganizations>>, TError, TData>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAdminUserOrganizationsQueryKey(userId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAdminUserOrganizations>>> = ({ signal }) => getAdminUserOrganizations(userId, requestOptions, signal);





   return  { queryKey, queryFn, enabled: userId !== null && userId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAdminUserOrganizations>>, TError, TData> & { queryKey: QueryKey }
}

export type GetAdminUserOrganizationsQueryResult = NonNullable<Awaited<ReturnType<typeof getAdminUserOrganizations>>>
export type GetAdminUserOrganizationsQueryError = unknown



export function useGetAdminUserOrganizations<TData = Awaited<ReturnType<typeof getAdminUserOrganizations>>, TError = unknown>(
 userId: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getAdminUserOrganizations>>, TError, TData>, request?: SecondParameter<typeof apiFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetAdminUserOrganizationsQueryOptions(userId,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}






export const deleteAdminUserProvider = (
    userId: string,
    provider: string,
 options?: SecondParameter<typeof apiFetch>,signal?: AbortSignal
) => {


      return apiFetch<AdminOkResponse>(
      {url: `/admin/users/${encodeURIComponent(String(userId))}/providers/${encodeURIComponent(String(provider))}`, method: 'DELETE', signal
    },
      options);
    }




export const getDeleteAdminUserProviderMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteAdminUserProvider>>, TError,{userId: string;provider: string}, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteAdminUserProvider>>, TError,{userId: string;provider: string}, TContext> => {

const mutationKey = ['deleteAdminUserProvider'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteAdminUserProvider>>, {userId: string;provider: string}> = (props) => {
          const {userId,provider} = props ?? {};

          return  deleteAdminUserProvider(userId,provider,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteAdminUserProviderMutationResult = NonNullable<Awaited<ReturnType<typeof deleteAdminUserProvider>>>

    export type DeleteAdminUserProviderMutationError = unknown

    export const useDeleteAdminUserProvider = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteAdminUserProvider>>, TError,{userId: string;provider: string}, TContext>, request?: SecondParameter<typeof apiFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof deleteAdminUserProvider>>,
        TError,
        {userId: string;provider: string},
        TContext
      > => {
      return useMutation(getDeleteAdminUserProviderMutationOptions(options));
    }
    export const setAdminUserStatus = (
    userId: string,
    setAdminUserStatusBody: SetAdminUserStatusBody,
 options?: SecondParameter<typeof apiFetch>,signal?: AbortSignal
) => {


      return apiFetch<AdminOkResponse>(
      {url: `/admin/users/${encodeURIComponent(String(userId))}/status`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: setAdminUserStatusBody, signal
    },
      options);
    }




export const getSetAdminUserStatusMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof setAdminUserStatus>>, TError,{userId: string;data: SetAdminUserStatusBody}, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof setAdminUserStatus>>, TError,{userId: string;data: SetAdminUserStatusBody}, TContext> => {

const mutationKey = ['setAdminUserStatus'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof setAdminUserStatus>>, {userId: string;data: SetAdminUserStatusBody}> = (props) => {
          const {userId,data} = props ?? {};

          return  setAdminUserStatus(userId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type SetAdminUserStatusMutationResult = NonNullable<Awaited<ReturnType<typeof setAdminUserStatus>>>
    export type SetAdminUserStatusMutationBody = SetAdminUserStatusBody
    export type SetAdminUserStatusMutationError = unknown

    export const useSetAdminUserStatus = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof setAdminUserStatus>>, TError,{userId: string;data: SetAdminUserStatusBody}, TContext>, request?: SecondParameter<typeof apiFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof setAdminUserStatus>>,
        TError,
        {userId: string;data: SetAdminUserStatusBody},
        TContext
      > => {
      return useMutation(getSetAdminUserStatusMutationOptions(options));
    }
    export const getAdminWebhookActivity = (

 options?: SecondParameter<typeof apiFetch>,signal?: AbortSignal
) => {


      return apiFetch<GetAdminWebhookActivity200>(
      {url: `/admin/webhook-activity`, method: 'GET', signal
    },
      options);
    }




export const getGetAdminWebhookActivityQueryKey = () => {
    return [
    `/admin/webhook-activity`
    ] as const;
    }


export const getGetAdminWebhookActivityQueryOptions = <TData = Awaited<ReturnType<typeof getAdminWebhookActivity>>, TError = unknown>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getAdminWebhookActivity>>, TError, TData>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAdminWebhookActivityQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAdminWebhookActivity>>> = ({ signal }) => getAdminWebhookActivity(requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAdminWebhookActivity>>, TError, TData> & { queryKey: QueryKey }
}

export type GetAdminWebhookActivityQueryResult = NonNullable<Awaited<ReturnType<typeof getAdminWebhookActivity>>>
export type GetAdminWebhookActivityQueryError = unknown



export function useGetAdminWebhookActivity<TData = Awaited<ReturnType<typeof getAdminWebhookActivity>>, TError = unknown>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getAdminWebhookActivity>>, TError, TData>, request?: SecondParameter<typeof apiFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetAdminWebhookActivityQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}






export const setAdminWebhookDrainRate = (
    setAdminWebhookDrainRateBody: SetAdminWebhookDrainRateBody,
 options?: SecondParameter<typeof apiFetch>,signal?: AbortSignal
) => {


      return apiFetch<SetAdminWebhookDrainRate200>(
      {url: `/admin/webhook-drain/rate`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: setAdminWebhookDrainRateBody, signal
    },
      options);
    }




export const getSetAdminWebhookDrainRateMutationOptions = <TError = ErrorEnvelope,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof setAdminWebhookDrainRate>>, TError,{data: SetAdminWebhookDrainRateBody}, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof setAdminWebhookDrainRate>>, TError,{data: SetAdminWebhookDrainRateBody}, TContext> => {

const mutationKey = ['setAdminWebhookDrainRate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof setAdminWebhookDrainRate>>, {data: SetAdminWebhookDrainRateBody}> = (props) => {
          const {data} = props ?? {};

          return  setAdminWebhookDrainRate(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type SetAdminWebhookDrainRateMutationResult = NonNullable<Awaited<ReturnType<typeof setAdminWebhookDrainRate>>>
    export type SetAdminWebhookDrainRateMutationBody = SetAdminWebhookDrainRateBody
    export type SetAdminWebhookDrainRateMutationError = ErrorEnvelope

    export const useSetAdminWebhookDrainRate = <TError = ErrorEnvelope,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof setAdminWebhookDrainRate>>, TError,{data: SetAdminWebhookDrainRateBody}, TContext>, request?: SecondParameter<typeof apiFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof setAdminWebhookDrainRate>>,
        TError,
        {data: SetAdminWebhookDrainRateBody},
        TContext
      > => {
      return useMutation(getSetAdminWebhookDrainRateMutationOptions(options));
    }
